(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-v2"] && !Shopify.designMode) return;
  try {
    
  // Deliberately NOT `shftd-marquee`: marquee-v2 defines that tag and its
  // implementation queries `.marquee-v2__track`. customElements.define throws
  // on a duplicate name, so whichever section loaded first would win and the
  // other would silently never measure.
  if (!customElements.get('shftd-announcement-bar')) {
    class ShftdAnnouncementBar extends HTMLElement {
      connectedCallback() {
        this._track = this.querySelector('.ab-v2__track');
        this._copy = this.querySelector('.ab-v2__copy');
        if (!this._track || !this._copy) return;

        // Read once: re-reading computed style on every resize forces a style
        // recalc the observer is already paying for.
        const styles = getComputedStyle(this);
        this._speed = parseFloat(styles.getPropertyValue('--speed')) || 60;

        // NaN means "no hover behaviour" (the property is only emitted when the
        // merchant enables it); 0 is a real value meaning stop, so this cannot
        // be a falsy check.
        this._hoverSpeed = parseFloat(styles.getPropertyValue('--hover-speed'));
        this._bindHover();

        // Reduced motion drives setup rather than a one-time bail: the OS
        // setting can be toggled off without a reload, and a permanent bail
        // would leave the band stuck on the CSS fallback duration, ignoring
        // the merchant's pixels-per-second.
        this._mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._onMotionChange = () => this._sync();
        if (this._mq.addEventListener) {
          this._mq.addEventListener('change', this._onMotionChange);
        }

        this._sync();
      }

      // The theme editor moves and re-renders section DOM, so teardown has to
      // be complete or observers accumulate across edits.
      disconnectedCallback() {
        this._teardown();
        if (this._mq && this._mq.removeEventListener) {
          this._mq.removeEventListener('change', this._onMotionChange);
        }
        this._mq = null;
        this._unbindHover();
      }

      // Hover speed rescales the running animation via playbackRate rather than
      // rewriting the duration, which would snap the track back to its start.
      // focusin/focusout mirror the pointer events so a keyboard user gets the
      // same slowdown; the unconditional focus pause in CSS still applies on
      // top of this for the links-in-a-moving-track case.
      _bindHover() {
        if (Number.isNaN(this._hoverSpeed)) return;
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          return;
        }

        this._enter = () => this._setRate(this._hoverSpeed / this._speed);
        this._leave = () => this._setRate(1);

        this.addEventListener('mouseenter', this._enter);
        this.addEventListener('mouseleave', this._leave);
        this.addEventListener('focusin', this._enter);
        this.addEventListener('focusout', this._leave);
      }

      _unbindHover() {
        if (!this._enter) return;
        this.removeEventListener('mouseenter', this._enter);
        this.removeEventListener('mouseleave', this._leave);
        this.removeEventListener('focusin', this._enter);
        this.removeEventListener('focusout', this._leave);
        this._enter = null;
        this._leave = null;
      }

      _setRate(rate) {
        if (!this._track || !this._track.getAnimations) return;
        const animations = this._track.getAnimations();
        for (let n = 0; n < animations.length; n += 1) {
          animations[n].playbackRate = rate;
        }
      }

      // Under reduced motion the CSS has already zeroed the animation, so
      // measuring would write a duration nothing reads — drop the observers
      // instead of paying for them.
      _sync() {
        if (this._mq && this._mq.matches) {
          this._teardown();
          return;
        }
        if (this._ro) return;

        // Force a re-measure: _lastWidth may be stale from before the toggle.
        this._lastWidth = undefined;
        this._measure();

        // Webfonts change the copy's width after first paint, and the observer
        // below will not catch it: this element's own box is unchanged.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this._measure());
        }

        if ('ResizeObserver' in window) {
          this._ro = new ResizeObserver(() => {
            window.clearTimeout(this._debounce);
            this._debounce = window.setTimeout(() => this._measure(), 150);
          });
          this._ro.observe(this);
        }
      }

      _teardown() {
        if (this._ro) {
          this._ro.disconnect();
          this._ro = null;
        }
        window.clearTimeout(this._debounce);
      }

      _measure() {
        // document.fonts.ready cannot be cancelled in disconnectedCallback, so
        // its callback can land after the theme editor swapped this section out.
        if (!this.isConnected) return;

        const width = this._copy.getBoundingClientRect().width;
        // Also covers a measure taken before layout: 0 would make the duration
        // 0s (or NaN if --speed were ever unparseable), freezing the band.
        if (!width) return;

        // A duration rewrite makes the track jump (the elapsed time is kept,
        // so the progress fraction changes), and a mobile address bar
        // showing/hiding fires resize constantly — skip no-op measures.
        if (this._lastWidth !== undefined && Math.abs(width - this._lastWidth) < 1) {
          return;
        }
        this._lastWidth = width;

        // Capture the current progress BEFORE rewriting the duration, then
        // re-seat the animation at the same fraction of the new duration so
        // the change is invisible instead of a visible jump.
        const durS = width / this._speed;
        let anim = null;
        let fraction = 0;
        if (this._track.getAnimations) {
          anim = this._track.getAnimations()[0] || null;
          if (anim && anim.effect && anim.effect.getComputedTiming) {
            const timing = anim.effect.getComputedTiming();
            if (typeof timing.progress === 'number') fraction = timing.progress;
          }
        }

        // width / px-per-second: perceived speed stays constant however many
        // messages the merchant added.
        this._track.style.setProperty('--marquee-dur', durS.toFixed(2) + 's');
        if (anim) anim.currentTime = fraction * durS * 1000;
      }
    }
    customElements.define('shftd-announcement-bar', ShftdAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const announcementBars = document.querySelectorAll('.announcement-bar');

  announcementBars.forEach(function (bar) {
    const colorValue = bar.style.getPropertyValue('--bar-color') || '#ff0000';
    const hex = colorValue.replace('#', '').trim();

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    bar.style.setProperty('--bar-color-r', isNaN(r) ? 255 : r);
    bar.style.setProperty('--bar-color-g', isNaN(g) ? 0 : g);
    bar.style.setProperty('--bar-color-b', isNaN(b) ? 0 : b);

    initRotator(bar);
  });

  function initRotator(bar) {
    const messages = bar.querySelectorAll('.announcement-bar__message');
    if (messages.length < 2) return;

    const interval = parseInt(bar.dataset.rotateInterval, 10);
    if (!interval || interval <= 0) return;

    const prefersReducedMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;

    let current = 0;
    let timer = null;

    function showNext() {
      const prev = messages[current];
      current = (current + 1) % messages.length;
      const next = messages[current];

      if (prefersReducedMotion) {
        prev.classList.remove('is-active');
        next.classList.add('is-active');
        return;
      }

      prev.classList.add('is-leaving');
      prev.classList.remove('is-active');
      next.classList.add('is-active');

      window.setTimeout(function () {
        prev.classList.remove('is-leaving');
      }, 650);
    }

    function start() {
      stop();
      timer = window.setInterval(showNext, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    start();

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-banner-v2')) {
    class ShftdBannerV2 extends HTMLElement {
      connectedCallback() {
        this._video = this.querySelector('video');
        if (!this._video) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this._video.removeAttribute('autoplay');
          try {
            this._video.pause();
          } catch (e) {
            /* not loaded yet */
          }
          return;
        }

        /* A looping background video only needs to run while it is on
           screen — pause it off screen, resume when it scrolls back. */
        if (!('IntersectionObserver' in window)) return;
        this._io = new IntersectionObserver(
          (entries) => {
            const visible = entries[0].isIntersecting;
            const result = visible ? this._video.play() : this._video.pause();
            if (result && typeof result.catch === 'function') result.catch(() => {});
          },
          { threshold: 0.05 }
        );
        this._io.observe(this);
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
      }
    }
    customElements.define('shftd-banner-v2', ShftdBannerV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer-v2"]) return;
  try {
    
  /* The line steppers are <shftd-qty> — canonically defined by
     main-product.liquid, but the drawer renders on EVERY page, so it carries
     the same guarded definition. Whichever section's JS runs first defines
     it; keep the two copies identical. */
  if (!customElements.get('shftd-qty')) {
    class ShftdQty extends HTMLElement {
      connectedCallback() {
        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._input = this.querySelector('.qty__input');
        if (!this._input) return;
        this.addEventListener(
          'click',
          (e) => {
            const minus = e.target.closest('[data-qty-minus]');
            const plus = e.target.closest('[data-qty-plus]');
            if (!minus && !plus) return;
            const min = parseInt(this._input.min, 10) || 1;
            const max = parseInt(this._input.max, 10) || Infinity;
            let v = parseInt(this._input.value, 10) || min;
            v = Math.min(max, Math.max(min, v + (plus ? 1 : -1)));
            if (v === parseInt(this._input.value, 10)) return;
            this._input.value = v;
            this.dispatchEvent(new CustomEvent('shftd-qty:change', { bubbles: true, detail: { value: v } }));
          },
          { signal }
        );
        this._input.addEventListener(
          'change',
          () => {
            const min = parseInt(this._input.min, 10) || 1;
            let v = parseInt(this._input.value, 10) || min;
            v = Math.max(min, v);
            this._input.value = v;
            this.dispatchEvent(new CustomEvent('shftd-qty:change', { bubbles: true, detail: { value: v } }));
          },
          { signal }
        );
      }
      disconnectedCallback() {
        if (this._abort) this._abort.abort();
      }
    }
    customElements.define('shftd-qty', ShftdQty);
  }

  if (!customElements.get('shftd-cart-drawer')) {
    class ShftdCartDrawer extends HTMLElement {
      connectedCallback() {
        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this._panel = this.querySelector('.cdrawer__panel');

        /* Capture-phase so the v2 drawer wins over the old theme's cart
           drawer script while both are on the page (pre-cutover). */
        document.addEventListener(
          'click',
          (e) => {
            const bubble = e.target.closest('#cart-icon-bubble');
            if (!bubble) return;
            e.preventDefault();
            e.stopPropagation();
            this.open();
          },
          { capture: true, signal }
        );

        this.addEventListener(
          'click',
          (e) => {
            if (e.target.closest('[data-cd-close]')) {
              const link = e.target.closest('a[data-cd-close]');
              if (!link) e.preventDefault();
              this.close();
              return;
            }
            const remove = e.target.closest('[data-cd-remove]');
            if (remove) {
              const line = remove.closest('[data-cd-line]');
              if (line) line.classList.add('is-pending');
              this._change(remove.dataset.lineKey, 0);
              return;
            }
            const addon = e.target.closest('[data-addon-add]');
            if (addon) this._add(addon);
          },
          { signal }
        );

        this.addEventListener(
          'shftd-qty:change',
          (e) => {
            const qty = e.target.closest('[data-line-key]');
            if (!qty) return;
            const line = qty.closest('[data-cd-line]');
            if (line) line.classList.add('is-pending');
            this._change(qty.dataset.lineKey, e.detail.value);
          },
          { signal }
        );

        document.addEventListener(
          'keydown',
          (e) => {
            /* LIFO Escape: yield to overlays stacked above this one (size
               guide z-400, gallery zoom z-400) so one keypress closes only
               the topmost layer. shftdEscHandled covers same-event handler
               ordering; the selector covers reverse ordering. */
            if (
              e.key === 'Escape'
              && !e.shftdEscHandled
              && this.hasAttribute('data-open')
              && !document.querySelector('shftd-sizeguide[data-open], .pdp__zoom:not([hidden])')
            ) {
              e.shftdEscHandled = true;
              this.close();
            }
            if (e.key === 'Tab' && this.hasAttribute('data-open')) this._trapFocus(e);
          },
          { signal }
        );

        /* v2 components announce mutations here (with the re-rendered drawer
           section when they had our section id). */
        document.addEventListener(
          'shftd:cart:changed',
          (e) => {
            const detail = e.detail || {};
            if (detail.sections && detail.sections[this.dataset.sectionId]) {
              this._swap(detail.sections[this.dataset.sectionId]);
              if (detail.cart) this._updateCount(detail.cart.item_count);
            } else {
              this._refresh(detail.cart);
            }
            if (detail.open) this.open();
          },
          { signal }
        );

        /* Bridge: v1 quick-adds publish through Dawn's pub/sub. */
        if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          this._unsub = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event && event.source === 'shftd-cart-drawer') return;
            this._refresh(event && event.cartData);
          });
        }
      }

      disconnectedCallback() {
        if (this._abort) this._abort.abort();
        if (this._unsub) this._unsub();
        /* Removed while open (editor re-render): release the scroll lock. */
        this._unlockScroll();
      }

      /* Refcounted scroll lock, shared across every v2 overlay via the
         html[data-shftd-locks] counter: overlays can open and close in any
         order (quick-add drawer -> cart drawer) and the page unlocks exactly
         when the LAST one closes. Snapshot-based restore is banned here — a
         snapshot taken while another overlay was open resurrects a stale
         'hidden' and freezes the page. */
      _lockScroll() {
        if (this._holdsLock) return;
        this._holdsLock = true;
        const html = document.documentElement;
        html.dataset.shftdLocks = String((parseInt(html.dataset.shftdLocks, 10) || 0) + 1);
        html.style.overflow = 'hidden';
      }

      _unlockScroll() {
        if (!this._holdsLock) return;
        this._holdsLock = false;
        const html = document.documentElement;
        const n = Math.max(0, (parseInt(html.dataset.shftdLocks, 10) || 1) - 1);
        if (n === 0) {
          delete html.dataset.shftdLocks;
          html.style.overflow = '';
        } else {
          html.dataset.shftdLocks = String(n);
        }
      }

      open() {
        if (this.hasAttribute('data-open')) return;
        this.setAttribute('data-open', '');
        this._prevFocus = document.activeElement;
        this._lockScroll();
        this._syncTiers();
        /* Focus lands on the close button — the exit is one Enter away. */
        const cdCloseBtn = this.querySelector('button[data-cd-close]');
        if (cdCloseBtn) cdCloseBtn.focus({ preventScroll: true });
        else if (this._panel) this._panel.focus({ preventScroll: true });
      }

      close() {
        if (!this.hasAttribute('data-open')) return;
        this.removeAttribute('data-open');
        this._unlockScroll();
        if (this._prevFocus && this._prevFocus.focus) this._prevFocus.focus({ preventScroll: true });
      }

      _trapFocus(e) {
        const focusables = this._panel.querySelectorAll(
          'a[href], button:not(:disabled), input:not(:disabled), [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      _updateCount(count) {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = count > 0 ? count : '';
        });
      }

      _publish(cart) {
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'shftd-cart-drawer', cartData: cart });
        }
      }

      _swap(sectionHtml) {
        const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const fresh = doc.querySelector('[data-cd-content]');
        const current = this.querySelector('[data-cd-content]');
        if (fresh && current) current.replaceWith(fresh);
        this.classList.remove('is-busy');
        this._syncTiers();
      }

      /* Scroll the tiers strip so the stage the cart holds leads the view,
         with the next two stages visible after it. Anchoring on the previous
         cell's own offset keeps the window on exact cell boundaries (a fixed
         cell-width offset would land mid-gap). */
      _syncTiers() {
        const strip = this.querySelector('[data-cd-tiers-strip]');
        if (!strip) return;
        const next = strip.querySelector('.is-next');
        const steps = strip.querySelectorAll('.cdrawer__tiers-step');
        const anchor = next || steps[steps.length - 1];
        if (!anchor) return;
        const lead = anchor.previousElementSibling || anchor;
        strip.scrollLeft = lead === anchor ? 0 : lead.offsetLeft;
      }

      /* Re-fetch our own section (Section Rendering API) — used when a
         mutation happened without our section id in the request. */
      _refresh(cart) {
        fetch(this._root + '?sections=' + this.dataset.sectionId)
          .then((r) => r.json())
          .then((sections) => {
            if (sections[this.dataset.sectionId]) this._swap(sections[this.dataset.sectionId]);
            if (cart) this._updateCount(cart.item_count);
          })
          .catch(() => this.classList.remove('is-busy'));
      }

      _change(lineKey, quantity) {
        this.classList.add('is-busy');
        fetch(this._root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity, sections: this.dataset.sectionId }),
        })
          .then((r) => {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .then((cart) => {
            if (cart.sections && cart.sections[this.dataset.sectionId]) {
              this._swap(cart.sections[this.dataset.sectionId]);
            } else {
              this._refresh(cart);
            }
            this._updateCount(cart.item_count);
            this._publish(cart);
          })
          .catch(() => {
            /* Roll back the optimistic pending state with fresh SSR truth */
            this._refresh(null);
          });
      }

      _add(btn) {
        btn.disabled = true;
        this.classList.add('is-busy');
        fetch(this._root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }],
            sections: this.dataset.sectionId,
          }),
        })
          .then((r) => {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .then((data) => {
            if (data.sections && data.sections[this.dataset.sectionId]) {
              this._swap(data.sections[this.dataset.sectionId]);
            }
            return fetch(this._root + 'cart.js').then((r) => r.json());
          })
          .then((cart) => {
            this._updateCount(cart.item_count);
            this._publish(cart);
            if (!this.querySelector('[data-cd-content]')) this._refresh(cart);
          })
          .catch(() => {
            btn.disabled = false;
            this._refresh(null);
          });
      }
    }
    customElements.define('shftd-cart-drawer', ShftdCartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-collapsible-v2')) {
    class ShftdCollapsibleV2 extends HTMLElement {
      connectedCallback() {
        if (this._abort) this._abort.abort();
        this._abort = new AbortController();
        const signal = this._abort.signal;

        // Delegated so rows added by the theme editor are handled without
        // re-binding, and so there is only ever one listener to tear down.
        this.addEventListener(
          'click',
          (event) => {
            const btn = event.target.closest('[data-cc-toggle]');
            if (!btn || !this.contains(btn)) return;
            const item = btn.closest('[data-cc-item]');
            if (!item) return;
            this._toggle(item, !item.classList.contains('is-open'));
          },
          { signal }
        );

        // Theme editor: selecting a block in the sidebar opens its row so the
        // merchant sees what they are editing.
        this.addEventListener(
          'shopify:block:select',
          (event) => {
            const item = event.target.closest('[data-cc-item]');
            if (item && item.querySelector('[data-cc-toggle]')) this._toggle(item, true);
          },
          { signal }
        );
      }

      disconnectedCallback() {
        if (this._abort) this._abort.abort();
      }

      _toggle(item, open) {
        if (open && !this.hasAttribute('data-multiple')) {
          this.querySelectorAll('[data-cc-item].is-open').forEach((other) => {
            if (other !== item) this._set(other, false);
          });
        }
        this._set(item, open);
      }

      _set(item, open) {
        item.classList.toggle('is-open', open);
        const btn = item.querySelector('[data-cc-toggle]');
        if (btn) btn.setAttribute('aria-expanded', String(open));
        // `inert` keeps collapsed content out of the tab order and the a11y
        // tree while leaving the grid-rows transition intact.
        const panel = item.querySelector('[data-cc-panel]');
        if (panel) panel.inert = !open;
      }
    }
    customElements.define('shftd-collapsible-v2', ShftdCollapsibleV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["entry-pass-tiers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-tier-carousel')) {
    class ShftdTierCarousel extends HTMLElement {
      connectedCallback() {
        this._track = this.querySelector('[data-track]');
        if (!this._track) return;
        this._all = Array.prototype.slice.call(this._track.children);
        this._real = this._all.filter((el) => !el.classList.contains('ept__cell--clone'));
        this._n = this._real.length;
        if (!this._n) return;
        // Clones before the first real card; the same count sits after the last.
        this._k = this._all.indexOf(this._real[0]);
        this._loop = this.hasAttribute('data-loop') && this._k > 0;
        // Clone cards are pointer-clickable duplicates, never tab stops.
        for (let i = 0; i < this._all.length; i += 1) {
          if (!this._all[i].classList.contains('ept__cell--clone')) continue;
          const stops = this._all[i].querySelectorAll('a, button');
          for (let j = 0; j < stops.length; j += 1) stops[j].tabIndex = -1;
        }

        this._bar = this.querySelector('[data-bar]');
        this._count = this.querySelector('[data-count]');
        this._prev = this.querySelector('[data-prev]');
        this._next = this.querySelector('[data-next]');
        this._toggle = this.querySelector('[data-toggle]');

        this._reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._pauseHover = this.hasAttribute('data-pause-hover');
        // Reduced motion never auto-advances, whatever the setting says.
        this._interval = this._reduced.matches ? 0 : parseInt(this.getAttribute('data-autoplay'), 10) || 0;
        if (!this._interval && this._toggle) this._toggle.hidden = true;

        this._timer = 0;
        this._playing = false;
        this._held = false; // hover / focus inside: hold the clock
        this._dragging = false; // finger or mouse down on the track
        this._inView = true;
        this._seated = false;
        this._target = -1; // index a programmatic scroll is heading to, -1 when idle
        this._ticking = false;
        this._settleTimer = 0;

        this._onScroll = () => {
          if (this._ticking) return;
          this._ticking = true;
          requestAnimationFrame(() => {
            this._update();
            this._ticking = false;
          });
        };
        this._onSettle = () => {
          this._target = -1;
          if (this._dragging) return; // re-seating under a held finger would cancel the gesture
          if (this._loop) this._wrap();
        };
        // Fallback for engines without scrollend: 120ms of silence is a settle.
        this._onScrollDebounced = () => {
          window.clearTimeout(this._settleTimer);
          this._settleTimer = window.setTimeout(this._onSettle, 120);
        };
        this._onPrev = () => {
          this._step(-1, false);
          this._restart();
        };
        this._onNext = () => {
          this._step(1, false);
          this._restart();
        };
        this._onKey = (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this._onPrev();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this._onNext();
          }
        };
        this._onToggle = () => (this._playing ? this._pause() : this._play());
        this._onHold = () => {
          this._held = true;
        };
        this._onRelease = () => {
          this._held = false;
          this._restart();
        };
        this._onDown = () => {
          this._dragging = true;
        };
        this._onUp = () => {
          if (!this._dragging) return;
          this._dragging = false;
          this._onScrollDebounced();
          this._restart();
        };
        this._onTick = () => {
          if (this._held || this._dragging || !this._inView || document.hidden) return;
          this._step(1, true);
        };
        this._onResize = () => {
          this._layout();
          this._onScroll();
        };

        if (this._prev) this._prev.addEventListener('click', this._onPrev);
        if (this._next) this._next.addEventListener('click', this._onNext);
        if (this._toggle) this._toggle.addEventListener('click', this._onToggle);
        this._track.addEventListener('keydown', this._onKey);
        this._track.addEventListener('scroll', this._onScroll, { passive: true });
        this._hasScrollEnd = 'onscrollend' in window;
        if (this._hasScrollEnd) {
          this._track.addEventListener('scrollend', this._onSettle);
        } else {
          this._track.addEventListener('scroll', this._onScrollDebounced, { passive: true });
        }
        this._track.addEventListener('pointerdown', this._onDown, { passive: true });
        window.addEventListener('pointerup', this._onUp, { passive: true });
        window.addEventListener('pointercancel', this._onUp, { passive: true });
        if (this._pauseHover) {
          this.addEventListener('mouseenter', this._onHold);
          this.addEventListener('mouseleave', this._onRelease);
          this.addEventListener('focusin', this._onHold);
          this.addEventListener('focusout', this._onRelease);
        }

        this._ro = new ResizeObserver(this._onResize);
        this._ro.observe(this._track);
        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver((entries) => {
            this._inView = entries[0].isIntersecting;
          });
          this._io.observe(this);
        }

        // Theme editor: selecting a tier brings it into view and holds the
        // clock while the merchant edits it.
        if (window.Shopify && window.Shopify.designMode) {
          this._onBlockSelect = (e) => {
            const i = this._real.indexOf(e.target);
            if (i < 0) return;
            const m = this._metrics();
            this._goTo(m.first + Math.min(i, m.last - m.first), m, false);
            this._held = true;
          };
          this._onBlockDeselect = (e) => {
            if (this._real.indexOf(e.target) < 0) return;
            this._held = false;
          };
          document.addEventListener('shopify:block:select', this._onBlockSelect);
          document.addEventListener('shopify:block:deselect', this._onBlockDeselect);
        }

        this._layout();
        this._update();
        if (this._interval) this._play();
      }

      disconnectedCallback() {
        this._pause();
        window.clearTimeout(this._settleTimer);
        if (this._ro) this._ro.disconnect();
        if (this._io) this._io.disconnect();
        if (this._prev) this._prev.removeEventListener('click', this._onPrev);
        if (this._next) this._next.removeEventListener('click', this._onNext);
        if (this._toggle) this._toggle.removeEventListener('click', this._onToggle);
        if (this._track) {
          this._track.removeEventListener('keydown', this._onKey);
          this._track.removeEventListener('scroll', this._onScroll);
          this._track.removeEventListener('scrollend', this._onSettle);
          this._track.removeEventListener('scroll', this._onScrollDebounced);
          this._track.removeEventListener('pointerdown', this._onDown);
        }
        window.removeEventListener('pointerup', this._onUp);
        window.removeEventListener('pointercancel', this._onUp);
        if (this._pauseHover) {
          this.removeEventListener('mouseenter', this._onHold);
          this.removeEventListener('mouseleave', this._onRelease);
          this.removeEventListener('focusin', this._onHold);
          this.removeEventListener('focusout', this._onRelease);
        }
        if (this._onBlockSelect) {
          document.removeEventListener('shopify:block:select', this._onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
        }
      }

      // Everything navigation and the readout need, measured once per call.
      // Cells share one width and one gap, so the track is a plain grid of
      // `stride` and the leftmost cell is scrollLeft / stride. `first`/`last`
      // bound the leftmost index: the real cards in loop mode (clones sit
      // outside them), the first card to the last full view otherwise.
      _metrics() {
        const t = this._track;
        const cs = getComputedStyle(t);
        const padL = parseFloat(cs.paddingLeft) || 0;
        const padR = parseFloat(cs.paddingRight) || 0;
        const gap = parseFloat(cs.columnGap) || 0;
        const inner = t.clientWidth - padL - padR;
        const cellW = this._real[0].getBoundingClientRect().width || inner;
        const stride = cellW + gap;
        const perView = Math.max(1, Math.round((inner + gap) / stride));
        const isStatic = perView >= this._n;
        const looping = this._loop && !isStatic;
        const first = looping ? this._k : 0;
        const last = looping ? first + this._n - 1 : Math.max(0, this._n - perView);
        const index = Math.round(t.scrollLeft / stride);
        return { stride, perView, isStatic, looping, first, last, index, maxLeft: t.scrollWidth - t.clientWidth };
      }

      // Static (every card fits) vs scrolling, and the loop's start seat.
      _layout() {
        let m = this._metrics();
        const wasLoop = this.classList.contains('ept__carousel--loop');
        this.classList.toggle('ept__carousel--loop', m.looping);
        if (wasLoop !== m.looping) m = this._metrics();
        if (m.isStatic) {
          this._seated = false;
          if (this._track.scrollLeft) this._track.scrollTo({ left: 0, behavior: 'auto' });
          return;
        }
        if (m.looping && !this._seated) {
          this._seated = true;
          this._goTo(m.first, m, true);
        }
      }

      // Loop only: a settled scroll inside a clone zone is moved onto the
      // identical real card, instantly, so the next step carries on from there.
      _wrap(m) {
        m = m || this._metrics();
        if (!m.looping) return m;
        if (m.index < m.first) this._goTo(m.index + this._n, m, true);
        else if (m.index > m.last) this._goTo(m.index - this._n, m, true);
        else return m;
        this._target = -1;
        return this._metrics();
      }

      _realIndex(m) {
        let r = m.index - m.first;
        if (m.looping) r = ((r % this._n) + this._n) % this._n;
        return Math.min(this._n - 1, Math.max(0, r));
      }

      _goTo(index, m, instant) {
        m = m || this._metrics();
        const left = Math.max(0, Math.min(m.maxLeft, index * m.stride));
        if (Math.abs(left - this._track.scrollLeft) < 1) return;
        this._target = instant ? -1 : index;
        this._track.scrollTo({ left, behavior: instant || this._reduced.matches ? 'auto' : 'smooth' });
      }

      _step(dir, auto) {
        let m = this._metrics();
        if (m.isStatic) return;
        // An idle track parked in a clone zone (a swipe that settled there)
        // is re-seated first so the step below always has a neighbour.
        if (m.looping && this._target < 0) m = this._wrap(m);
        const from = this._target >= 0 ? this._target : m.index;
        let to = from + dir;
        if (m.looping) {
          to = Math.max(0, Math.min(this._all.length - 1, to));
        } else {
          if (to > m.last) {
            // Autoplay reaching the end without loop simply stops there.
            if (auto) this._pause();
            to = m.last;
          }
          if (to < 0) to = 0;
        }
        if (to === from) return;
        this._goTo(to, m, false);
      }

      _update() {
        const m = this._metrics();
        if (this._bar) this._bar.hidden = m.isStatic;
        if (m.isStatic) {
          if (this._playing) this._pause();
          return;
        }
        if (this._count) {
          const pad = (v) => String(v).padStart(2, '0');
          this._count.textContent = pad(this._realIndex(m) + 1) + ' / ' + pad(this._n);
        }
        if (this._prev) this._prev.disabled = !m.looping && m.index <= 0;
        if (this._next) this._next.disabled = !m.looping && m.index >= m.last;
      }

      _play() {
        if (!this._interval || this._playing) return;
        if (this._metrics().isStatic) return;
        this._playing = true;
        this._timer = window.setInterval(this._onTick, this._interval);
        this._label();
      }

      _pause() {
        window.clearInterval(this._timer);
        this._timer = 0;
        this._playing = false;
        this._label();
      }

      // Manual navigation resets the clock so the next auto-advance is a full
      // interval away, not a beat after the click.
      _restart() {
        if (!this._playing) return;
        window.clearInterval(this._timer);
        this._timer = window.setInterval(this._onTick, this._interval);
      }

      _label() {
        if (!this._toggle) return;
        const key = this._playing ? 'labelPause' : 'labelPlay';
        this._toggle.textContent = this._toggle.dataset[key] || '';
      }
    }
    customElements.define('shftd-tier-carousel', ShftdTierCarousel);
  }

  if (!customElements.get('shftd-tier-marquee')) {
    class ShftdTierMarquee extends HTMLElement {
      connectedCallback() {
        this._track = this.querySelector('[data-track]');
        this._copy = this.querySelector('[data-copy]');
        if (!this._track || !this._copy) return;

        // The clone is a visual duplicate: clickable with a pointer, but never
        // a tab stop — one visible card would otherwise cost the keyboard user
        // two. The card snippet renders the link, so it is done here.
        const clone = this.querySelector('[data-clone]');
        if (clone) {
          const stops = clone.querySelectorAll('a, button');
          for (let n = 0; n < stops.length; n += 1) stops[n].tabIndex = -1;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        // Custom properties inherit, so the section root's inline --ept-speed
        // reads here. Read once to avoid a style recalc on every resize.
        this._speed = parseFloat(getComputedStyle(this).getPropertyValue('--ept-speed')) || 40;

        this._measure();
        // Webfonts change the copy's width after first paint, and the observer
        // below won't catch it: the viewport's own box is unchanged.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this._measure());
        }
        if ('ResizeObserver' in window) {
          this._ro = new ResizeObserver(() => {
            window.clearTimeout(this._debounce);
            this._debounce = window.setTimeout(() => this._measure(), 150);
          });
          this._ro.observe(this);
        }

        // Theme editor: hold the band while a tier is selected.
        if (window.Shopify && window.Shopify.designMode) {
          this._onBlockSelect = (e) => {
            if (this.contains(e.target)) this.classList.add('is-paused');
          };
          this._onBlockDeselect = (e) => {
            if (this.contains(e.target)) this.classList.remove('is-paused');
          };
          document.addEventListener('shopify:block:select', this._onBlockSelect);
          document.addEventListener('shopify:block:deselect', this._onBlockDeselect);
        }
      }

      disconnectedCallback() {
        if (this._ro) this._ro.disconnect();
        window.clearTimeout(this._debounce);
        if (this._onBlockSelect) {
          document.removeEventListener('shopify:block:select', this._onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
        }
      }

      _measure() {
        const width = this._copy.getBoundingClientRect().width;
        if (!width) return;
        // Mobile address-bar show/hide fires resize constantly; a duration
        // rewrite for the same width would only make the track jump.
        if (this._lastWidth !== undefined && Math.abs(width - this._lastWidth) < 1) return;
        this._lastWidth = width;

        // Capture the current progress BEFORE rewriting the duration, then
        // re-seat the animation at the same fraction of the new duration so
        // the change is invisible instead of a visible jump.
        const durS = width / this._speed;
        let anim = null;
        let fraction = 0;
        if (this._track.getAnimations) {
          anim = this._track.getAnimations()[0] || null;
          if (anim && anim.effect && anim.effect.getComputedTiming) {
            const timing = anim.effect.getComputedTiming();
            if (typeof timing.progress === 'number') fraction = timing.progress;
          }
        }
        this._track.style.setProperty('--ept-mdur', durS.toFixed(2) + 's');
        if (anim) anim.currentTime = fraction * durS * 1000;
      }
    }
    customElements.define('shftd-tier-marquee', ShftdTierMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-offers-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-product-offers')) {
    class ShftdProductOffers extends HTMLElement {
      connectedCallback() {
        if (this._abort) this._abort.abort();
        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._timers = new Set();
        this._variantCache = new WeakMap();

        this.addEventListener(
          'click',
          (e) => {
            const opt = e.target.closest('[data-po-opt]');
            if (opt) this._pick(opt);
          },
          { signal }
        );
        this.addEventListener(
          'submit',
          (e) => {
            const form = e.target.closest('form.poff__form');
            if (form) this._submit(e, form);
          },
          { signal }
        );

        this.querySelectorAll('[data-po-card][data-po-variants]').forEach((card) => this._markAvailability(card));
      }

      disconnectedCallback() {
        if (this._abort) this._abort.abort();
        if (this._timers) this._timers.forEach((t) => clearTimeout(t));
      }

      _variants(card) {
        let variants = this._variantCache.get(card);
        if (!variants) {
          try {
            variants = JSON.parse(card.dataset.poVariants || '[]');
          } catch (e) {
            variants = [];
          }
          this._variantCache.set(card, variants);
        }
        return variants;
      }

      _selected(card) {
        return Array.from(card.querySelectorAll('[data-po-option]')).map((group) => {
          const btn = group.querySelector('[data-po-opt].is-selected');
          return btn ? btn.dataset.value : null;
        });
      }

      _pick(btn) {
        const group = btn.closest('[data-po-option]');
        const card = btn.closest('[data-po-card]');
        if (!group || !card || btn.classList.contains('is-selected')) return;
        group.querySelectorAll('[data-po-opt]').forEach((b) => {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        const label = group.querySelector('[data-po-opt-value]');
        if (label) label.textContent = btn.dataset.value;
        this._apply(card);
      }

      /* A value is "unavailable" when no sellable variant carries it together
         with the other groups' current picks. */
      _markAvailability(card) {
        const variants = this._variants(card);
        const selected = this._selected(card);
        card.querySelectorAll('[data-po-option]').forEach((group, gi) => {
          group.querySelectorAll('[data-po-opt]').forEach((btn) => {
            const ok = variants.some(
              (v) => v.available && v.options.every((o, i) => (i === gi ? o === btn.dataset.value : o === selected[i]))
            );
            btn.classList.toggle('is-unavailable', !ok);
          });
        });
      }

      _apply(card) {
        const selected = this._selected(card);
        const variant = this._variants(card).find((v) => v.options.every((o, i) => o === selected[i])) || null;
        this._markAvailability(card);
        const q = (sel) => card.querySelector(sel);
        const atc = q('[data-po-atc]');
        const atcLabel = q('[data-po-atc-label]');
        const atcEntries = q('[data-po-atc-entries]');
        const error = q('[data-po-error]');
        if (error) error.textContent = '';

        if (!variant) {
          if (atc) atc.disabled = true;
          if (atcLabel) atcLabel.textContent = this.dataset.labelUnavailable;
          if (atcEntries) atcEntries.textContent = '';
          const compare = q('[data-po-compare]');
          if (compare) compare.hidden = true;
          return;
        }

        const input = q('[data-po-variant-input]');
        if (input) input.value = variant.id;

        const price = q('[data-po-price]');
        if (price) price.textContent = variant.price;
        const compare = q('[data-po-compare]');
        if (compare) {
          compare.hidden = !variant.compare;
          if (variant.compare) compare.textContent = variant.compare;
        }

        const entries = Number(variant.entries || 0).toLocaleString('en-US');
        card.querySelectorAll('[data-po-total]').forEach((el) => {
          el.textContent = entries;
        });

        if (atc) atc.disabled = !variant.available;
        if (atcLabel) atcLabel.textContent = variant.available ? card.dataset.labelAdd : this.dataset.labelSoldOut;
        if (atcEntries) {
          atcEntries.textContent = variant.available ? '· ' + entries + ' ' + this.dataset.labelEntries : '';
        }
      }

      _later(fn, ms) {
        const t = setTimeout(() => {
          this._timers.delete(t);
          fn();
        }, ms);
        this._timers.add(t);
      }

      _submit(e, form) {
        e.preventDefault();
        const atc = form.querySelector('[data-po-atc]');
        const error = form.querySelector('[data-po-error]');
        if (atc && atc.classList.contains('is-busy')) return;
        if (error) error.textContent = '';
        const busy = (on) => {
          if (!atc) return;
          atc.classList.toggle('is-busy', on);
          if (on) atc.setAttribute('aria-busy', 'true');
          else atc.removeAttribute('aria-busy');
        };
        busy(true);

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const body = new FormData(form);
        const drawer = document.querySelector('shftd-cart-drawer');
        if (drawer && drawer.dataset.sectionId) body.append('sections', drawer.dataset.sectionId);

        fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body })
          .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
          .then(({ ok, data }) => {
            busy(false);
            if (!ok) {
              if (error) error.textContent = data.description || data.message || this.dataset.labelError;
              return;
            }
            if (atc) {
              atc.classList.add('is-added');
              this._later(() => atc.classList.remove('is-added'), 1600);
            }
            fetch(root + 'cart.js')
              .then((r) => r.json())
              .then((cart) => {
                if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
                  window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: cart });
                }
                document.dispatchEvent(
                  new CustomEvent('shftd:cart:changed', {
                    detail: { cart, sections: data.sections || null, open: true },
                  })
                );
              })
              .catch(() => {});
          })
          .catch(() => {
            busy(false);
            if (error) error.textContent = this.dataset.labelError;
          });
      }
    }
    customElements.define('shftd-product-offers', ShftdProductOffers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-featured-product')) {
    class ShftdFeaturedProduct extends HTMLElement {
      connectedCallback() {
        if (this._abort) this._abort.abort();
        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

        this._variants = [];
        const json = this.querySelector('[data-fp-variants]');
        if (json) {
          try {
            this._variants = JSON.parse(json.textContent);
          } catch (e) {
            this._variants = [];
          }
        }
        this._groups = Array.from(this.querySelectorAll('[data-fp-option]'));
        this._selected = this._groups.map((g) => {
          const btn = g.querySelector('[data-fp-opt].is-selected');
          return btn ? btn.dataset.value : null;
        });
        this._track = this.querySelector('[data-fp-track]');
        this._items = this._track ? Array.from(this._track.querySelectorAll('[data-fp-media]')) : [];
        this._thumbs = Array.from(this.querySelectorAll('[data-fp-thumb]'));
        this._form = this.querySelector('form');

        // One delegated listener for every control in the section.
        this.addEventListener(
          'click',
          (e) => {
            const opt = e.target.closest('[data-fp-opt]');
            if (opt) return this._pick(opt);
            const thumb = e.target.closest('[data-fp-thumb]');
            if (thumb) return this._goTo(parseInt(thumb.dataset.index, 10));
            if (e.target.closest('[data-fp-prev]')) return this._step(-1);
            if (e.target.closest('[data-fp-next]')) return this._step(1);
            if (e.target.closest('[data-fp-qty-minus]')) return this._qty(-1);
            if (e.target.closest('[data-fp-qty-plus]')) return this._qty(1);
          },
          { signal }
        );

        const qty = this.querySelector('[data-fp-qty-input]');
        if (qty) {
          qty.addEventListener(
            'change',
            () => {
              const min = parseInt(qty.min, 10) || 1;
              qty.value = Math.max(min, parseInt(qty.value, 10) || min);
            },
            { signal }
          );
        }

        // A swipe on the track moves the active thumbnail with it.
        if (this._track && this._thumbs.length) {
          this._track.addEventListener(
            'scroll',
            () => {
              clearTimeout(this._scrollT);
              this._scrollT = setTimeout(() => this._setThumb(this._current()), 80);
            },
            { signal, passive: true }
          );
        }

        if (this._form) this._form.addEventListener('submit', (e) => this._submit(e), { signal });
        if (this._groups.length) this._markAvailability();

        /* Sticky offset under any sticky sections above (the header): written
           to the section root so the sticky info column reads it. */
        this._root = this.closest('.fprod-v2') || this;
        if (this._root.classList.contains('fprod-v2--sticky')) {
          this._syncTop = () => {
            let top = 0;
            document.querySelectorAll('.shopify-section').forEach((sec) => {
              const above = sec.compareDocumentPosition(this) & Node.DOCUMENT_POSITION_FOLLOWING;
              if (above && getComputedStyle(sec).position === 'sticky') top += sec.getBoundingClientRect().height;
            });
            this._root.style.setProperty('--fp-top', Math.round(top) + 'px');
          };
          window.addEventListener('resize', this._syncTop, { passive: true, signal });
          this._syncTop();
        }
      }

      disconnectedCallback() {
        if (this._abort) this._abort.abort();
        clearTimeout(this._scrollT);
      }

      /* --- Variants ------------------------------------------------------ */
      _pick(btn) {
        const group = btn.closest('[data-fp-option]');
        if (!group) return;
        const index = parseInt(group.dataset.fpOption, 10);
        if (this._selected[index] === btn.dataset.value) return;
        this._selected[index] = btn.dataset.value;
        group.querySelectorAll('[data-fp-opt]').forEach((b) => {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        const label = group.querySelector('[data-fp-opt-value]');
        if (label) label.textContent = btn.dataset.value;
        this._apply();
      }

      _find() {
        return this._variants.find((v) => v.options.every((o, i) => o === this._selected[i])) || null;
      }

      /* A value is "unavailable" when no sellable variant carries it together
         with the other groups' current picks. */
      _markAvailability() {
        this._groups.forEach((group, gi) => {
          group.querySelectorAll('[data-fp-opt]').forEach((btn) => {
            const ok = this._variants.some(
              (v) =>
                v.available &&
                v.options.every((o, i) => (i === gi ? o === btn.dataset.value : o === this._selected[i]))
            );
            btn.classList.toggle('is-unavailable', !ok);
          });
        });
      }

      _apply() {
        const variant = this._find();
        this._markAvailability();
        const q = (sel) => this.querySelector(sel);
        const atc = q('[data-fp-atc]');
        const atcLabel = q('[data-fp-atc-label]');
        const atcEntries = q('[data-fp-atc-entries]');
        const low = q('[data-fp-low-stock]');

        if (!variant) {
          if (atc) atc.disabled = true;
          if (atcLabel) atcLabel.textContent = this.dataset.labelUnavailable;
          if (atcEntries) atcEntries.textContent = '';
          if (low) low.hidden = true;
          return;
        }

        const input = q('[data-fp-variant-input]');
        if (input) input.value = variant.id;

        const price = q('[data-fp-price]');
        if (price) {
          price.textContent = variant.price;
          price.classList.toggle('price--promo', !!variant.compare);
        }
        const compare = q('[data-fp-compare]');
        if (compare) {
          compare.hidden = !variant.compare;
          if (variant.compare) compare.textContent = variant.compare;
        }

        const entries = variant.entries.toLocaleString('en-US');
        const capsule = q('[data-fp-capsule-entries]');
        if (capsule) capsule.textContent = entries;
        this.querySelectorAll('[data-fp-pill] .pill__main, [data-fp-media-pill] .pill__main').forEach((el) => {
          el.textContent = entries + ' ' + this.dataset.labelEntries;
        });

        if (atc) atc.disabled = !variant.available;
        if (atcLabel) atcLabel.textContent = variant.available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
        if (atcEntries) {
          atcEntries.textContent = variant.available ? '· ' + entries + ' ' + this.dataset.labelEntries : '';
        }

        if (low) {
          const picker = low.closest('[data-fp-picker]');
          const threshold = picker ? parseInt(picker.dataset.lowStockThreshold, 10) || 0 : 0;
          const show =
            threshold > 0 &&
            variant.inventory_managed &&
            variant.inventory_quantity > 0 &&
            variant.inventory_quantity <= threshold;
          low.hidden = !show;
          if (show) {
            low.textContent = (picker.dataset.lowStockTemplate || '')
              .replace('@count@', variant.inventory_quantity)
              .replace('@value@', variant.options[variant.options.length - 1]);
          }
        }

        if (variant.media_id) {
          const i = this._items.findIndex((el) => el.dataset.mediaId === String(variant.media_id));
          if (i > -1) this._goTo(i);
        }

        this.dispatchEvent(new CustomEvent('shftd:variant:change', { bubbles: true, detail: { variant } }));
      }

      /* --- Gallery ------------------------------------------------------- */
      _current() {
        if (!this._track || !this._items.length) return 0;
        return Math.round(this._track.scrollLeft / (this._track.clientWidth || 1));
      }

      _goTo(i) {
        if (!this._track || !this._items[i]) return;
        this._track.scrollTo({
          left: i * this._track.clientWidth,
          behavior: this._reduced.matches ? 'auto' : 'smooth',
        });
        this._setThumb(i);
      }

      _step(dir) {
        this._goTo(Math.min(this._items.length - 1, Math.max(0, this._current() + dir)));
      }

      _setThumb(i) {
        this._thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      }

      /* --- Quantity ------------------------------------------------------ */
      _qty(dir) {
        const input = this.querySelector('[data-fp-qty-input]');
        if (!input) return;
        const min = parseInt(input.min, 10) || 1;
        input.value = Math.max(min, (parseInt(input.value, 10) || min) + dir);
      }

      /* --- Add to cart ---------------------------------------------------
         Same contract as the product page form: cart/add.js with the v2
         drawer's section id, then cart.js, then 'shftd:cart:changed' with
         open: true so the drawer slides in with fresh SSR HTML. */
      _submit(e) {
        e.preventDefault();
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const atc = this._form.querySelector('[data-fp-atc]');
        const error = this._form.querySelector('[data-fp-form-error]');
        if (error) error.hidden = true;
        if (atc) atc.classList.add('is-busy');

        const body = new FormData(this._form);
        const drawer = document.querySelector('shftd-cart-drawer');
        if (drawer && drawer.dataset.sectionId) body.append('sections', drawer.dataset.sectionId);

        fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body })
          .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
          .then(({ ok, data }) => {
            if (atc) atc.classList.remove('is-busy');
            if (!ok) {
              if (error) {
                error.textContent = data.description || data.message || '';
                error.hidden = !error.textContent;
              }
              return;
            }
            if (atc) {
              atc.classList.add('is-added');
              setTimeout(() => atc.classList.remove('is-added'), 1600);
            }
            fetch(root + 'cart.js')
              .then((r) => r.json())
              .then((cart) => {
                if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
                  window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: cart });
                }
                document.dispatchEvent(
                  new CustomEvent('shftd:cart:changed', {
                    detail: { cart, sections: data.sections || null, open: true },
                  })
                );
              })
              .catch(() => {});
          })
          .catch(() => {
            if (atc) atc.classList.remove('is-busy');
            if (error) {
              error.textContent = 'Error';
              error.hidden = false;
            }
          });
      }
    }
    customElements.define('shftd-featured-product', ShftdFeaturedProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giveaway-rules"] && !Shopify.designMode) return;
  try {
    
(function() {
  const links = document.querySelectorAll('.gr__sidenav-link');
  if (!links.length) return;

  const headings = Array.from(links).map(link => {
    const id = link.getAttribute('href').slice(1);
    return document.getElementById(id);
  }).filter(Boolean);

  const activate = (id) => {
    links.forEach(l => {
      l.classList.toggle('is-active', l.getAttribute('href') === '#' + id);
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) activate(entry.target.id);
    });
  }, { rootMargin: '-20% 0px -70% 0px' });

  headings.forEach(h => observer.observe(h));

  links.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const target = document.querySelector(link.getAttribute('href'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    link.addEventListener('dragstart', e => e.preventDefault());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-header')) {
    class ShftdHeader extends HTMLElement {
      connectedCallback() {
        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._openedItem = null;
        this._closeTimer = 0;
        this._hoverFine = window.matchMedia('(hover: hover) and (pointer: fine)');

        this.querySelectorAll('[data-hdr-item]').forEach((item) => {
          const btn = item.querySelector('[data-hdr-toggle]');
          const panel = item.querySelector('[data-hdr-panel]');
          if (!btn || !panel) return;
          btn.addEventListener(
            'click',
            () => {
              /* Hover already opened this panel: the click that follows the
                 mouse's arrival must not toggle it shut — that made every
                 first click a dud. The click confirms the hover-open; only
                 a later deliberate click closes. */
              if (item.classList.contains('is-open')) {
                if (item._openedByHover) {
                  item._openedByHover = false;
                  return;
                }
                this._closePanel();
              } else {
                this._openPanel(item);
              }
            },
            { signal }
          );
          item.addEventListener(
            'mouseenter',
            () => {
              if (!this._hoverFine.matches) return;
              clearTimeout(this._closeTimer);
              if (!item.classList.contains('is-open')) item._openedByHover = true;
              this._openPanel(item);
            },
            { signal }
          );
          item.addEventListener(
            'mouseleave',
            () => {
              if (!this._hoverFine.matches) return;
              clearTimeout(this._closeTimer);
              this._closeTimer = setTimeout(() => this._closePanel(), 200);
            },
            { signal }
          );
        });

        /* pointerdown, not click: iOS Safari only synthesizes click events on
           elements it deems clickable, so an outside tap on plain content
           would never reach a click listener and the panel would stay open. */
        document.addEventListener(
          'pointerdown',
          (e) => {
            if (!this.contains(e.target)) {
              this._closePanel();
              this._closeSearch();
            }
          },
          { signal }
        );
        document.addEventListener(
          'keydown',
          (e) => {
            if (e.key !== 'Escape' || e.shftdEscHandled) return;
            /* LIFO Escape: overlays stacked above the header (cart drawer,
               size guide, zoom) own the keypress. */
            if (document.querySelector('shftd-cart-drawer[data-open], shftd-sizeguide[data-open], .pdp__zoom:not([hidden])')) return;
            if (this.classList.contains('is-drawer-open')) {
              e.shftdEscHandled = true;
              this._closeDrawer();
            } else if (this.classList.contains('is-search-open')) {
              e.shftdEscHandled = true;
              this._closeSearch();
              if (this._searchToggle) this._searchToggle.focus();
            } else if (this._openedItem) {
              e.shftdEscHandled = true;
              const btn = this._openedItem.querySelector('[data-hdr-toggle]');
              this._closePanel();
              if (btn) btn.focus();
            }
          },
          { signal }
        );

        this._searchPanel = this.querySelector('[data-hdr-search]');
        this._searchToggle = this.querySelector('[data-hdr-search-toggle]');
        if (this._searchPanel && this._searchToggle) {
          this._searchInput = this._searchPanel.querySelector('[data-hdr-search-input]');
          this._searchResults = this._searchPanel.querySelector('[data-hdr-search-results]');
          this._searchToggle.addEventListener(
            'click',
            (e) => {
              e.preventDefault();
              if (this.classList.contains('is-search-open')) this._closeSearch();
              else this._openSearch();
            },
            { signal }
          );
          const searchClose = this._searchPanel.querySelector('[data-hdr-search-close]');
          if (searchClose) searchClose.addEventListener('click', () => this._closeSearch(), { signal });
          this._searchInput.addEventListener(
            'input',
            () => {
              clearTimeout(this._searchTimer);
              this._searchTimer = setTimeout(() => this._suggest(), 200);
            },
            { signal }
          );
        }

        this._burger = this.querySelector('[data-hdr-burger]');
        if (this._burger) this._burger.addEventListener('click', () => this._openDrawer(), { signal });
        const close = this.querySelector('[data-hdr-close]');
        if (close) close.addEventListener('click', () => this._closeDrawer(), { signal });
        const scrim = this.querySelector('[data-hdr-scrim]');
        if (scrim) scrim.addEventListener('click', () => this._closeDrawer(), { signal });

        this._ticking = false;
        this._onScroll = () => {
          if (this._ticking) return;
          this._ticking = true;
          requestAnimationFrame(() => {
            this.classList.toggle('is-scrolled', window.scrollY > 4);
            this._ticking = false;
          });
        };
        window.addEventListener('scroll', this._onScroll, { passive: true, signal });
        this._onScroll();

        this._count = this.querySelector('[data-cart-count]');
        if (this._count && window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          this._unsubCart = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
            const n = event && event.cartData && typeof event.cartData.item_count === 'number' ? event.cartData.item_count : null;
            if (n === null) this._fetchCount();
            else this._setCount(n);
          });
        }
      }

      disconnectedCallback() {
        this._abort.abort();
        clearTimeout(this._closeTimer);
        clearTimeout(this._searchTimer);
        if (this._suggestAbort) this._suggestAbort.abort();
        if (this._unsubCart) this._unsubCart();
        this._unlockScroll();
      }

      /* Refcounted scroll lock shared across v2 overlays via
         html[data-shftd-locks] — a counter instead of blind writes, so
         overlays stacked in any order can never strand the page locked. */
      _lockScroll() {
        if (this._holdsLock) return;
        this._holdsLock = true;
        const html = document.documentElement;
        html.dataset.shftdLocks = String((parseInt(html.dataset.shftdLocks, 10) || 0) + 1);
        html.style.overflow = 'hidden';
      }

      _unlockScroll() {
        if (!this._holdsLock) return;
        this._holdsLock = false;
        const html = document.documentElement;
        const n = Math.max(0, (parseInt(html.dataset.shftdLocks, 10) || 1) - 1);
        if (n === 0) {
          delete html.dataset.shftdLocks;
          html.style.overflow = '';
        } else {
          html.dataset.shftdLocks = String(n);
        }
      }

      _openPanel(item) {
        if (this._openedItem === item) return;
        this._closePanel();
        this._closeSearch();
        this._openedItem = item;
        item.classList.add('is-open');
        item.querySelector('[data-hdr-toggle]').setAttribute('aria-expanded', 'true');
      }

      _closePanel() {
        const item = this._openedItem;
        if (!item) return;
        this._openedItem = null;
        item._openedByHover = false;
        item.classList.remove('is-open');
        item.querySelector('[data-hdr-toggle]').setAttribute('aria-expanded', 'false');
      }

      _openSearch() {
        if (!this._searchPanel) return;
        this._closePanel();
        this._closeDrawer();
        this.classList.add('is-search-open');
        this._searchToggle.setAttribute('aria-expanded', 'true');
        this._searchInput.focus();
      }

      _closeSearch() {
        if (!this.classList.contains('is-search-open')) return;
        this.classList.remove('is-search-open');
        this._searchToggle.setAttribute('aria-expanded', 'false');
        clearTimeout(this._searchTimer);
        if (this._suggestAbort) this._suggestAbort.abort();
      }

      _suggest() {
        const q = this._searchInput.value.trim();
        if (this._suggestAbort) this._suggestAbort.abort();
        if (q.length < 2) {
          this._searchResults.hidden = true;
          this._searchResults.textContent = '';
          return;
        }
        this._suggestAbort = new AbortController();
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const params = new URLSearchParams({
          q: q,
          'resources[type]': 'product,collection,page',
          'resources[limit]': '4',
          'resources[options][unavailable_products]': 'last',
        });
        fetch(root + 'search/suggest.json?' + params.toString(), { signal: this._suggestAbort.signal })
          .then((r) => r.json())
          .then((d) => this._renderSuggest(d, q))
          .catch(() => {
            /* silent: submitting the form still reaches the full search page */
          });
      }

      /* API-controlled strings are written with textContent only. */
      _renderSuggest(data, q) {
        const res = data && data.resources && data.resources.results;
        if (!res) return;
        const wrap = this._searchResults;
        const labels = wrap.dataset;
        wrap.textContent = '';

        const group = (label, items, withImage) => {
          if (!items || !items.length) return null;
          const div = document.createElement('div');
          div.className = 'hdr__search-group';
          const head = document.createElement('p');
          head.className = 'lbl';
          head.textContent = label;
          div.appendChild(head);
          const ul = document.createElement('ul');
          items.forEach((item) => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.className = 'hdr__search-item';
            a.href = item.url;
            if (withImage) {
              const img = document.createElement('img');
              img.className = 'hdr__search-thumb';
              img.loading = 'lazy';
              img.alt = '';
              const src = (item.featured_image && item.featured_image.url) || item.image;
              if (src) img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
              a.appendChild(img);
            }
            const title = document.createElement('span');
            title.textContent = item.title;
            a.appendChild(title);
            li.appendChild(a);
            ul.appendChild(li);
          });
          div.appendChild(ul);
          return div;
        };

        const groups = [
          group(labels.labelProducts, res.products, true),
          group(labels.labelCollections, res.collections, false),
          group(labels.labelPages, res.pages, false),
        ].filter(Boolean);

        if (groups.length) {
          const grid = document.createElement('div');
          grid.className = 'hdr__search-grid';
          groups.forEach((g) => grid.appendChild(g));
          wrap.appendChild(grid);
        } else {
          const empty = document.createElement('p');
          empty.className = 'hdr__search-empty';
          empty.textContent = labels.labelNoResults;
          wrap.appendChild(empty);
        }

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const all = document.createElement('a');
        all.className = 'link-arrow hdr__search-all';
        all.href = root + 'search?q=' + encodeURIComponent(q);
        all.textContent = labels.labelViewAll + ' ';
        const ico = document.createElement('span');
        ico.className = 'ico';
        ico.style.setProperty('--icon', 'var(--icon-arrow-right)');
        all.appendChild(ico);
        wrap.appendChild(all);
        wrap.hidden = false;
      }

      _openDrawer() {
        this._closePanel();
        this._closeSearch();
        this.classList.add('is-drawer-open');
        if (this._burger) this._burger.setAttribute('aria-expanded', 'true');
        this._lockScroll();
        /* Focus lands on the close button — the exit is one Enter away. */
        const close = this.querySelector('[data-hdr-close]');
        if (close) close.focus({ preventScroll: true });
      }

      _closeDrawer() {
        if (!this.classList.contains('is-drawer-open')) return;
        this.classList.remove('is-drawer-open');
        if (this._burger) {
          this._burger.setAttribute('aria-expanded', 'false');
          this._burger.focus();
        }
        this._unlockScroll();
      }

      _setCount(n) {
        this._count.textContent = n > 0 ? String(n) : '';
      }

      _fetchCount() {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart.js')
          .then((r) => r.json())
          .then((d) => this._setCount(d.item_count))
          .catch(() => {});
      }
    }
    customElements.define('shftd-header', ShftdHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  var body  = document.querySelector('.help-article__body');
  var list  = document.querySelector('[data-help-toc]');
  var group = document.querySelector('[data-help-toc-group]');
  if (!body || !list || !group) return;

  var headings = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));
  if (!headings.length) return;

  function slugify(text) {
    return (text || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  }

  headings.forEach(function (h, i) {
    if (h.id) return;
    var base = slugify(h.textContent);
    var candidate = base;
    var n = 2;
    while (document.getElementById(candidate)) {
      candidate = base + '-' + n++;
    }
    h.id = candidate;
  });

  list.innerHTML = headings.map(function (h) {
    var sub = h.tagName === 'H3' ? ' help-article__sidenav-link--sub' : '';
    var text = (h.textContent || '').trim()
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return (
      '<li><a href="#' + h.id + '" class="help-article__sidenav-link' + sub + '">' +
      text +
      '</a></li>'
    );
  }).join('');

  group.hidden = false;

  var links = list.querySelectorAll('.help-article__sidenav-link');

  function activate(id) {
    links.forEach(function (l) {
      l.classList.toggle('is-active', l.getAttribute('href') === '#' + id);
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) activate(entry.target.id);
    });
  }, { rootMargin: '-20% 0px -70% 0px' });

  headings.forEach(function (h) { observer.observe(h); });

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.querySelector(link.getAttribute('href'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    link.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-articles-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-help-search')) {
    class ShftdHelpSearch extends HTMLElement {
      connectedCallback() {
        if (this._abort) this._abort.abort();
        this._abort = new AbortController();
        this._timer = null;
        const input = this.querySelector('[data-ha-input]');
        if (!input) return;
        input.addEventListener(
          'input',
          () => {
            clearTimeout(this._timer);
            this._timer = setTimeout(() => this._filter(input.value), 120);
          },
          { signal: this._abort.signal }
        );
      }

      disconnectedCallback() {
        clearTimeout(this._timer);
        if (this._abort) this._abort.abort();
      }

      _norm(s) {
        return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      }

      _fill(tpl, n) {
        return tpl ? tpl.replace('__COUNT__', String(n)) : '';
      }

      _filter(raw) {
        const q = this._norm(raw.trim());
        // Queried live so cards added by the theme editor are always filtered.
        const cards = this.querySelectorAll('[data-ha-card]');
        const count = this.querySelector('[data-ha-count]');
        const empty = this.querySelector('[data-ha-empty]');
        const status = this.querySelector('[data-ha-status]');
        const grid = this.querySelector('[data-ha-grid]');
        let shown = 0;
        cards.forEach((card) => {
          const hit = q === '' || this._norm(card.dataset.search || '').includes(q);
          card.hidden = !hit;
          if (hit) shown += 1;
        });
        if (empty) empty.hidden = shown !== 0;
        // Hide the grid itself so its hairline background does not linger.
        if (grid) grid.hidden = shown === 0;
        if (count) {
          const n = q === '' ? parseInt(count.dataset.total, 10) : shown;
          count.textContent = this._fill(n === 1 ? count.dataset.one : count.dataset.other, n);
        }
        if (status) {
          status.textContent =
            shown === 0
              ? status.dataset.none || ''
              : this._fill(shown === 1 ? status.dataset.one : status.dataset.other, shown);
        }
      }
    }
    customElements.define('shftd-help-search', ShftdHelpSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-categories-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-help-categories')) {
    class ShftdHelpCategories extends HTMLElement {
      connectedCallback() {
        if (this._abort) this._abort.abort();
        this._abort = new AbortController();
        // Delegated so rows added by the theme editor are handled without
        // re-binding, and so there is only ever one listener to tear down.
        this.addEventListener(
          'click',
          (event) => {
            const btn = event.target.closest('[data-hc-toggle]');
            if (!btn || !this.contains(btn)) return;
            const item = btn.closest('[data-hc-item]');
            if (!item) return;
            const open = item.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', String(open));
            const panel = item.querySelector('[data-hc-panel]');
            // `inert` keeps collapsed links out of the tab order and the a11y
            // tree while leaving the grid-rows transition intact.
            if (panel) panel.inert = !open;
          },
          { signal: this._abort.signal }
        );
      }

      disconnectedCallback() {
        if (this._abort) this._abort.abort();
      }
    }
    customElements.define('shftd-help-categories', ShftdHelpCategories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-hero-v2')) {
    class ShftdHeroV2 extends HTMLElement {
      connectedCallback() {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reduced) {
          this.querySelectorAll('video').forEach((video) => {
            video.removeAttribute('autoplay');
            try {
              video.pause();
            } catch (e) {
              /* not loaded yet */
            }
          });
        }

        if (this.dataset.parallax !== 'true' || reduced) return;
        this._layers = this.querySelectorAll('img.hero-v2__media-el');
        if (!this._layers.length) return;

        this.classList.add('hero-v2--parallax');
        this._inView = false;
        this._ticking = false;
        this._onScroll = () => {
          if (this._ticking || !this._inView) return;
          this._ticking = true;
          requestAnimationFrame(() => {
            this._update();
            this._ticking = false;
          });
        };
        this._io = new IntersectionObserver((entries) => {
          this._inView = entries[0].isIntersecting;
          if (this._inView) this._update();
        });
        this._io.observe(this);
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });
        this._update();
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
      }

      _update() {
        const rect = this.getBoundingClientRect();
        const vh = window.innerHeight || 1;
        const raw = (rect.top + rect.height / 2 - vh / 2) / ((vh + rect.height) / 2);
        const progress = Math.max(-1, Math.min(1, raw));
        const shift = (-progress * rect.height * 0.06).toFixed(1);
        this._layers.forEach((el) => {
          el.style.translate = '0 ' + shift + 'px';
        });
      }
    }
    customElements.define('shftd-hero-v2', ShftdHeroV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-iwt-media-v2')) {
    class ShftdIwtMediaV2 extends HTMLElement {
      connectedCallback() {
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.querySelectorAll('video').forEach((video) => {
          video.removeAttribute('autoplay');
          try {
            video.pause();
          } catch (e) {
            /* not loaded yet */
          }
        });
      }
    }
    customElements.define('shftd-iwt-media-v2', ShftdIwtMediaV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-accordion')) {
    class ShftdAccordion extends HTMLElement {
      connectedCallback() {
        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._multiple = this.hasAttribute('data-multiple');
        this._items = Array.from(this.querySelectorAll('[data-acc-item]'));
        this._items.forEach((item) => {
          const btn = item.querySelector('[data-acc-toggle]');
          if (!btn) return;
          btn.addEventListener(
            'click',
            () => {
              if (item.classList.contains('is-open')) this._close(item);
              else this._open(item);
            },
            { signal }
          );
        });
      }

      disconnectedCallback() {
        this._abort.abort();
      }

      _open(item) {
        if (!this._multiple) {
          this._items.forEach((other) => {
            if (other !== item) this._close(other);
          });
        }
        item.classList.add('is-open');
        item.querySelector('[data-acc-toggle]').setAttribute('aria-expanded', 'true');
        this._showMedia(item.dataset.index);
      }

      _close(item) {
        if (!item.classList.contains('is-open')) return;
        item.classList.remove('is-open');
        item.querySelector('[data-acc-toggle]').setAttribute('aria-expanded', 'false');
      }

      /* An item without its own media layer keeps the current image showing. */
      _showMedia(index) {
        const next = this.querySelector('[data-acc-media][data-for="' + index + '"]');
        if (!next || next.classList.contains('is-active')) return;
        this.querySelectorAll('[data-acc-media].is-active').forEach((el) => el.classList.remove('is-active'));
        next.classList.add('is-active');
      }
    }
    customElements.define('shftd-accordion', ShftdAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-collection')) {
    class ShftdCollection extends HTMLElement {
      connectedCallback() {
        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._drawer = this.querySelector('[data-drawer]');
        this._form = this.querySelector('[data-facets-form]');
        this._sectionId = this.dataset.sectionId;
        this._opener = null;
        this._fetchAbort = null;
        this._changeTimer = 0;

        this.addEventListener('click', (e) => this._onClick(e), { signal });

        if (this._form) {
          /* The quick-view panel lives inside the facets form — its events
             must never trigger a facet re-render. */
          this._form.addEventListener(
            'change',
            () => {
              if (this._drawer.getAttribute('data-open') === 'quick') return;
              clearTimeout(this._changeTimer);
              this._changeTimer = setTimeout(() => this._applyFacets(), 350);
            },
            { signal }
          );
          this._form.addEventListener(
            'submit',
            (e) => {
              e.preventDefault();
              if (this._drawer.getAttribute('data-open') === 'quick') return;
              clearTimeout(this._changeTimer);
              this._applyFacets();
              this._closeDrawer();
            },
            { signal }
          );
        }

        document.addEventListener(
          'keydown',
          (e) => {
            /* LIFO Escape: during the quick-add handoff the cart drawer sits
               above this drawer — the keypress belongs to it, not us. */
            if (
              e.key === 'Escape'
              && !e.shftdEscHandled
              && this.classList.contains('is-drawer-open')
              && !document.querySelector('shftd-cart-drawer[data-open]')
            ) {
              e.shftdEscHandled = true;
              this._closeDrawer();
            }
            if (e.key === 'Tab' && this.classList.contains('is-drawer-open')) this._trapFocus(e);
          },
          { signal }
        );

        this._syncStickyTop = () => {
          let top = 0;
          document.querySelectorAll('.shopify-section').forEach((sec) => {
            const isAbove = sec.compareDocumentPosition(this) & Node.DOCUMENT_POSITION_FOLLOWING;
            if (isAbove && getComputedStyle(sec).position === 'sticky') {
              top += sec.getBoundingClientRect().height;
            }
          });
          this.style.setProperty('--mcol-top', Math.round(top) + 'px');
        };
        window.addEventListener('resize', this._syncStickyTop, { passive: true, signal });
        this._syncStickyTop();

        this._bindDynamic();
      }

      disconnectedCallback() {
        this._abort.abort();
        clearTimeout(this._changeTimer);
        if (this._fetchAbort) this._fetchAbort.abort();
        if (this._io) this._io.disconnect();
        this._unlockScroll();
      }

      /* Refcounted scroll lock shared across v2 overlays via
         html[data-shftd-locks]: the quick-add flow opens the cart drawer
         while this drawer is still open, and a bare overflow write from
         either side strands the page. The counter releases exactly when the
         last overlay closes, whatever the order. */
      _lockScroll() {
        if (this._holdsLock) return;
        this._holdsLock = true;
        const html = document.documentElement;
        html.dataset.shftdLocks = String((parseInt(html.dataset.shftdLocks, 10) || 0) + 1);
        html.style.overflow = 'hidden';
      }

      _unlockScroll() {
        if (!this._holdsLock) return;
        this._holdsLock = false;
        const html = document.documentElement;
        const n = Math.max(0, (parseInt(html.dataset.shftdLocks, 10) || 1) - 1);
        if (n === 0) {
          delete html.dataset.shftdLocks;
          html.style.overflow = '';
        } else {
          html.dataset.shftdLocks = String(n);
        }
      }

      /* Delegated clicks survive Section Rendering replacements. */
      _onClick(e) {
        const open = e.target.closest('[data-drawer-open]');
        if (open) {
          this._openDrawer(open.dataset.drawerOpen, open.dataset.drawerHeading, open);
          return;
        }
        if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-scrim]')) {
          this._closeDrawer();
          return;
        }
        const facetLink = e.target.closest('[data-facet-link]');
        if (facetLink) {
          e.preventDefault();
          this._renderFromUrl(facetLink.getAttribute('href'));
          return;
        }
        const more = e.target.closest('[data-load-more]');
        if (more) {
          more.disabled = true;
          this._loadNext(more.dataset.nextUrl);
          return;
        }
        const qa = e.target.closest('[data-quick-add]');
        if (qa) {
          e.preventDefault();
          this._quickAdd(qa);
        }
      }

      _bindDynamic() {
        if (this._io) this._io.disconnect();
        const sentinel = this.querySelector('[data-infinite]');
        if (sentinel) {
          this._io = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
              this._io.disconnect();
              this._loadNext(sentinel.dataset.nextUrl);
            }
          });
          this._io.observe(sentinel);
        }
      }

      /* ---- Drawer ---- */
      _openDrawer(panel, heading, opener) {
        this._opener = opener || null;
        this._drawer.setAttribute('data-open', panel);
        const title = this.querySelector('[data-drawer-title]');
        if (title && heading) title.textContent = heading;
        this.classList.add('is-drawer-open');
        this._lockScroll();
        const close = this.querySelector('[data-drawer-close]');
        if (close) close.focus();
      }

      _closeDrawer() {
        if (!this.classList.contains('is-drawer-open')) return;
        this.classList.remove('is-drawer-open');
        this._drawer.removeAttribute('data-open');
        this._unlockScroll();
        /* Facet re-renders replace the toolbar, detaching the stored opener —
           focusing a detached node is a silent no-op that drops keyboard
           focus to <body>. Re-resolve by selector first. */
        const opener = (this._opener && this._opener.isConnected && this._opener)
          || this.querySelector('[data-drawer-open="filter"]');
        if (opener) opener.focus();
        this._opener = null;
      }

      _trapFocus(e) {
        const focusables = this._drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])');
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      /* ---- Facets via Section Rendering ---- */
      _applyFacets() {
        const params = new URLSearchParams();
        new FormData(this._form).forEach((value, key) => {
          if (String(value).trim() !== '') params.append(key, value);
        });
        const url = this.dataset.collectionUrl + '?' + params.toString();
        this._renderFromUrl(url);
      }

      _renderFromUrl(url) {
        if (this._fetchAbort) this._fetchAbort.abort();
        this._fetchAbort = new AbortController();
        this.classList.add('is-loading');
        const glue = url.indexOf('?') > -1 ? '&' : '?';
        fetch(url + glue + 'section_id=' + this._sectionId, { signal: this._fetchAbort.signal })
          .then((r) => {
            if (!r.ok) throw new Error(r.status);
            return r.text();
          })
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const target = doc.querySelector('[data-collection-target]');
            if (!target) throw new Error('no target');
            this.querySelector('[data-collection-target]').replaceChildren(...target.children);
            ['[data-drawer-filters]', '[data-drawer-sort]', '[data-drawer-foot]'].forEach((sel) => {
              const mine = this.querySelector(sel);
              const theirs = doc.querySelector(sel);
              if (mine && theirs) mine.replaceChildren(...theirs.children);
            });
            history.replaceState(null, '', url);
            this.classList.remove('is-loading');
            this._bindDynamic();
          })
          .catch((err) => {
            if (err && err.name === 'AbortError') return;
            window.location.href = url;
          });
      }

      _loadNext(nextUrl) {
        if (this._fetchAbort) this._fetchAbort.abort();
        this._fetchAbort = new AbortController();
        const glue = nextUrl.indexOf('?') > -1 ? '&' : '?';
        fetch(nextUrl + glue + 'section_id=' + this._sectionId, { signal: this._fetchAbort.signal })
          .then((r) => {
            if (!r.ok) throw new Error(r.status);
            return r.text();
          })
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const newItems = doc.querySelectorAll('.pgrid .pgrid__item');
            const grid = this.querySelector('.pgrid');
            if (grid) newItems.forEach((item) => grid.appendChild(item));
            const pagination = this.querySelector('[data-pagination]');
            const nextPagination = doc.querySelector('[data-pagination]');
            if (pagination && nextPagination) pagination.replaceChildren(...nextPagination.children);
            this._bindDynamic();
          })
          .catch((err) => {
            if (err && err.name === 'AbortError') return;
            window.location.href = nextUrl;
          });
      }

      /* ---- Quick view: a stripped PDP in the drawer ---- */
      _quickAdd(btn) {
        const count = parseInt(btn.dataset.variantCount, 10) || 1;
        if (count === 1) {
          this._addToCart(btn.dataset.variantId, btn);
          return;
        }
        const body = this.querySelector('[data-quick-body]');
        body.textContent = '';
        this._openDrawer('quick', btn.dataset.productTitle, btn);
        fetch(btn.dataset.productUrl + '.js')
          .then((r) => r.json())
          .then((product) => this._quickView(product, body))
          .catch(() => {
            window.location.href = btn.dataset.productUrl;
          });
      }

      /* API-controlled strings are written with textContent only. */
      _quickView(product, body) {
        body.textContent = '';
        const labels = body.dataset;
        const first = product.variants.find((v) => v.available) || product.variants[0];
        const state = { qty: 1, sel: first ? first.options.slice() : [] };

        const img = document.createElement('img');
        img.className = 'mcol__qv-img';
        img.alt = '';
        body.appendChild(img);

        const head = document.createElement('div');
        head.className = 'mcol__qv-head';
        const title = document.createElement('p');
        title.className = 'mcol__qv-title';
        title.textContent = product.title;
        const price = document.createElement('span');
        price.className = 'price';
        head.append(title, price);
        body.appendChild(head);

        const optButtons = [];
        (product.options || []).forEach((opt, idx) => {
          const values = opt.values || Array.from(new Set(product.variants.map((v) => v.options[idx])));
          if (values.length === 1 && values[0] === 'Default Title') return;
          const group = document.createElement('div');
          group.className = 'mcol__group';
          const lbl = document.createElement('p');
          lbl.className = 'lbl';
          lbl.textContent = opt.name || String(opt);
          const wrap = document.createElement('div');
          wrap.className = 'mcol__sizes';
          values.forEach((value) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'mcol__qv-opt';
            b.textContent = value;
            b.addEventListener('click', () => {
              state.sel[idx] = value;
              update();
            });
            optButtons.push({ b, idx, value });
            wrap.appendChild(b);
          });
          group.append(lbl, wrap);
          body.appendChild(group);
        });

        const qtyGroup = document.createElement('div');
        qtyGroup.className = 'mcol__group';
        const qtyLbl = document.createElement('p');
        qtyLbl.className = 'lbl';
        qtyLbl.textContent = labels.labelQty || 'Quantity';
        const qty = document.createElement('div');
        qty.className = 'mcol__qty';
        const minus = document.createElement('button');
        minus.type = 'button';
        minus.textContent = '−';
        const qin = document.createElement('input');
        qin.type = 'number';
        qin.min = '1';
        qin.value = '1';
        qin.setAttribute('aria-label', labels.labelQty || 'Quantity');
        const plus = document.createElement('button');
        plus.type = 'button';
        plus.textContent = '+';
        const setQty = (n) => {
          state.qty = Math.max(1, n);
          qin.value = state.qty;
        };
        minus.addEventListener('click', () => setQty(state.qty - 1));
        plus.addEventListener('click', () => setQty(state.qty + 1));
        qin.addEventListener('change', () => setQty(parseInt(qin.value, 10) || 1));
        qty.append(minus, qin, plus);
        qtyGroup.append(qtyLbl, qty);
        body.appendChild(qtyGroup);

        const atc = document.createElement('button');
        atc.type = 'button';
        atc.className = 'btn btn--lg btn--primary btn--full mcol__qv-atc';
        body.appendChild(atc);

        const findVariant = () => product.variants.find((v) => v.options.every((o, i) => o === state.sel[i]));
        const update = () => {
          const v = findVariant();
          price.textContent = this._formatMoney(v ? v.price : product.price);
          const src = (v && v.featured_image && v.featured_image.src) || product.featured_image || (product.images && product.images[0]);
          if (src) img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800';
          const sold = !v || !v.available;
          atc.disabled = sold;
          atc.textContent = sold ? labels.labelSold || 'Sold out' : labels.labelAdd || 'Add to cart';
          optButtons.forEach((o) => o.b.classList.toggle('is-active', state.sel[o.idx] === o.value));
        };
        atc.addEventListener('click', () => {
          const v = findVariant();
          if (!v) return;
          atc.disabled = true;
          this._addToCart(
            v.id,
            atc,
            () => setTimeout(() => this._closeDrawer(), 600),
            state.qty,
            () => {
              /* failed add: restore a usable button */
              atc.disabled = false;
              update();
            }
          );
        });
        update();
      }

      _addToCart(variantId, btn, done, qty, fail) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        /* Ask the add call to re-render the v2 drawer's section in the same
           round trip (Section Rendering API), so the drawer swaps its content
           without a second fetch — same pattern as the product form. */
        const drawer = document.querySelector('shftd-cart-drawer');
        const payload = { id: parseInt(variantId, 10), quantity: qty || 1 };
        if (drawer && drawer.dataset.sectionId) payload.sections = drawer.dataset.sectionId;
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then((r) => {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .then((data) => {
            if (btn) {
              btn.classList.add('is-added');
              setTimeout(() => btn.classList.remove('is-added'), 1600);
            }
            /* Refresh the cart and hand the data to whoever listens: the v2
               drawer takes 'shftd:cart:changed' (and opens itself), the old
               theme's drawer and header count take Dawn's pub/sub. */
            fetch(root + 'cart.js')
              .then((r) => r.json())
              .then((cart) => {
                if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
                  window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: cart });
                }
                document.dispatchEvent(
                  new CustomEvent('shftd:cart:changed', {
                    detail: { cart, sections: data.sections || null, open: true },
                  })
                );
              })
              .catch(() => {});
            if (done) done();
          })
          .catch(() => {
            if (fail) fail();
            else if (btn) btn.disabled = false;
          });
      }

      /* Minor display formatting only — server prices stay authoritative. */
      _formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }
    }
    customElements.define('shftd-collection', ShftdCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-v2"]) return;
  try {
    
  if (!customElements.get('shftd-toc')) {
    class ShftdToc extends HTMLElement {
      connectedCallback() {
        const scope = this.closest('.mainpage-v2__in') || document;
        const content = scope.querySelector('.prose-v2');
        const list = this.querySelector('[data-toc-list]');
        if (! content || ! list) return;
        

        const headings = Array.from(content.querySelectorAll('h2'));
        if (! headings.length) return;
        

        const used = new Set();
        const frag = document.createDocumentFragment();

        headings.forEach((heading, index) => {
          const text = (heading.textContent || '').trim();
          if (!heading.id) {
            let slug = text
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '')
              .slice(0, 48);
            if (! slug) 
              slug = 'section';
            
            let id = slug;
            let n = 2;
            while (used.has(id) || document.getElementById(id)) {
              id = slug + '-' + n++;
            }
            heading.id = id;
          }
          used.add(heading.id);

          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = text || 'Section ' + (
            index + 1
          );
          li.appendChild(link);
          frag.appendChild(li);
        });

        list.replaceChildren(frag);
        this.hidden = false;

        this._spy(headings);
      }


/*
   Marks the section the reader is currently in. Deliberately not an
   IntersectionObserver keyed on "is the heading visible": the last
   section is usually too short to ever reach a trigger band, so it would
   never light up. Instead the current heading is the last one whose top
   has passed the trigger line, and hitting the bottom of the page always
   selects the final heading however short it is.
*/
      _spy(headings) {
        const links = new Map(Array.from(this.querySelectorAll('a')).map((a) => [a.getAttribute('href').slice(1), a]));
        const setActive = (id) => {
          links.forEach((a, key) => a.classList.toggle('is-active', key === id));
        };

        let ticking = false;

        const update = () => {
          const line = window.innerHeight * 0.25;
          const scrolled = window.scrollY + window.innerHeight;
          const atBottom = scrolled >= document.documentElement.scrollHeight - 2;

          let current = headings[0];
          if (atBottom) {
            current = headings[headings.length - 1];
          } else {
            for (const heading of headings) {
              if (heading.getBoundingClientRect().top<= line) current = heading;
              else break;
            }
          }
          if (current) setActive(current.id);
        };

        this._onScroll = () => {
                if (ticking) return;
                
                ticking = true;
                requestAnimationFrame(() => {
                  update();
                  ticking = false;
                });
              };

              window.addEventListener('scroll', this._onScroll, {passive: true});
              window.addEventListener('resize', this._onScroll, {passive: true});
              update();
            }

            disconnectedCallback() {
              if (!this._onScroll) return;
              
              window.removeEventListener('scroll', this._onScroll);
              window.removeEventListener('resize', this._onScroll);
            }
          }
          customElements.define('shftd-toc', ShftdToc);
        }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!customElements.get('shftd-qty')) {
      class ShftdQty extends HTMLElement {
        connectedCallback() {
          this._abort = new AbortController();
          const signal = this._abort.signal;
          this._input = this.querySelector('.qty__input');
          if (!this._input) return;
          this.addEventListener(
            'click',
            (e) => {
              const minus = e.target.closest('[data-qty-minus]');
              const plus = e.target.closest('[data-qty-plus]');
              if (!minus && !plus) return;
              const min = parseInt(this._input.min, 10) || 1;
              const max = parseInt(this._input.max, 10) || Infinity;
              let v = parseInt(this._input.value, 10) || min;
              v = Math.min(max, Math.max(min, v + (plus ? 1 : -1)));
              if (v === parseInt(this._input.value, 10)) return;
              this._input.value = v;
              this.dispatchEvent(new CustomEvent('shftd-qty:change', { bubbles: true, detail: { value: v } }));
            },
            { signal }
          );
          this._input.addEventListener(
            'change',
            () => {
              const min = parseInt(this._input.min, 10) || 1;
              let v = parseInt(this._input.value, 10) || min;
              v = Math.max(min, v);
              this._input.value = v;
              this.dispatchEvent(new CustomEvent('shftd-qty:change', { bubbles: true, detail: { value: v } }));
            },
            { signal }
          );
        }
        disconnectedCallback() {
          if (this._abort) this._abort.abort();
        }
      }
      customElements.define('shftd-qty', ShftdQty);
    }

    if (!customElements.get('shftd-acc')) {
      /* Animates the native <details> by tweening the WHOLE element's height
         (body-only height tweens fight the body's own padding and snap at the
         end). Interruptible: re-clicking mid-animation reverses from the
         current height. prefers-reduced-motion falls back to instant toggle. */
      class ShftdAcc extends HTMLElement {
        connectedCallback() {
          this._abort = new AbortController();
          this._details = this.querySelector('details');
          this._summary = this.querySelector('summary');
          if (!this._details || !this._summary) return;
          this._summary.addEventListener(
            'click',
            (e) => {
              e.preventDefault();
              if (reduced.matches) {
                this._details.open = !this._details.open;
                return;
              }
              this._toggle();
            },
            { signal: this._abort.signal }
          );
        }

        disconnectedCallback() {
          if (this._abort) this._abort.abort();
        }

        _toggle() {
          const d = this._details;
          const startH = d.offsetHeight; /* mid-animation aware: read BEFORE cancel */
          if (this._anim) this._anim.cancel();
          const opening = this._closing || !d.open;
          this._closing = !opening;

          let endH;
          const cs = getComputedStyle(d);
          const borders = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
          if (opening) {
            d.open = true;
            endH = d.offsetHeight;
          } else {
            endH = this._summary.offsetHeight + borders;
          }

          d.style.overflow = 'hidden';
          this._anim = d.animate([{ height: startH + 'px' }, { height: endH + 'px' }], {
            duration: opening ? 280 : 220,
            easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
          });
          const cleanup = () => {
            d.style.overflow = '';
            this._anim = null;
          };
          this._anim.oncancel = cleanup;
          this._anim.onfinish = () => {
            if (!opening) d.open = false;
            this._closing = false;
            cleanup();
          };
        }
      }
      customElements.define('shftd-acc', ShftdAcc);
    }

    if (!customElements.get('shftd-countdown')) {
      class ShftdCountdown extends HTMLElement {
        connectedCallback() {
          const target = new Date(this.dataset.target || '').getTime();
          if (Number.isNaN(target)) return;
          const pad = (n) => String(n).padStart(2, '0');
          const tick = () => {
            let s = Math.floor((target - Date.now()) / 1000);
            if (s <= 0) {
              this.textContent = '00:00:00';
              clearInterval(this._timer);
              return;
            }
            const d = Math.floor(s / 86400);
            s -= d * 86400;
            const h = Math.floor(s / 3600);
            const m = Math.floor((s % 3600) / 60);
            const sec = s % 60;
            this.textContent = (d > 0 ? d + 'D ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
          };
          tick();
          this._timer = setInterval(tick, 1000);
        }
        disconnectedCallback() {
          clearInterval(this._timer);
        }
      }
      customElements.define('shftd-countdown', ShftdCountdown);
    }

    if (!customElements.get('shftd-gallery')) {
      class ShftdGallery extends HTMLElement {
        connectedCallback() {
          this._abort = new AbortController();
          const signal = this._abort.signal;
          this._track = this.querySelector('[data-gallery-track]');
          if (!this._track) return;
          this._items = Array.from(this._track.querySelectorAll('[data-gallery-media]'));
          this._thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));

          this.addEventListener(
            'click',
            (e) => {
              const thumb = e.target.closest('[data-gallery-thumb]');
              if (thumb) return this._goTo(parseInt(thumb.dataset.index, 10));
              if (e.target.closest('[data-gallery-prev]')) return this._step(-1);
              if (e.target.closest('[data-gallery-next]')) return this._step(1);
              if (e.target.closest('[data-gallery-zoom-close]')) return this._closeZoom();
              /* Anywhere on the open zoom overlay closes it — the cursor
                 already promises zoom-out, and on touch there is no Escape.
                 Must run before the media check (media never matches inside
                 the overlay, but keep the order explicit). */
              if (e.target.closest('[data-gallery-zoom]')) return this._closeZoom();
              const media = e.target.closest('[data-gallery-media]');
              if (media && this.hasAttribute('data-zoom')) this._openZoom(media);
            },
            { signal }
          );

          let ticking = false;
          this._track.addEventListener(
            'scroll',
            () => {
              if (ticking) return;
              ticking = true;
              requestAnimationFrame(() => {
                this._syncActive();
                ticking = false;
              });
            },
            { signal, passive: true }
          );

          /* Variant switch → show the variant's media */
          const section = this.closest('.shftd-v2.pdp');
          if (section) {
            section.addEventListener(
              'shftd:variant:change',
              (e) => {
                const id = e.detail && e.detail.variant && e.detail.variant.media_id;
                if (!id) return;
                const index = this._items.findIndex((m) => m.dataset.mediaId === String(id));
                if (index >= 0) this._goTo(index);
              },
              { signal }
            );
          }

          document.addEventListener(
            'keydown',
            (e) => {
              /* shftdEscHandled: cross-component convention — the first
                 overlay to consume an Escape marks the event, so one press
                 closes one layer even though every overlay listens on
                 document and runs against the same event. */
              if (e.key !== 'Escape' || e.shftdEscHandled) return;
              const zoom = this.querySelector('[data-gallery-zoom]');
              if (zoom && !zoom.hidden) {
                e.shftdEscHandled = true;
                this._closeZoom();
              }
            },
            { signal }
          );

          /* Sticky offset under any sticky sections (header) — set on the
             section root so the sticky buy column reads it too. */
          this._syncTop = () => {
            let top = 0;
            document.querySelectorAll('.shopify-section').forEach((sec) => {
              const isAbove = sec.compareDocumentPosition(this) & Node.DOCUMENT_POSITION_FOLLOWING;
              if (isAbove && getComputedStyle(sec).position === 'sticky') top += sec.getBoundingClientRect().height;
            });
            (this.closest('.shftd-v2.pdp') || this).style.setProperty('--pdp-top', Math.round(top) + 'px');
          };
          window.addEventListener('resize', this._syncTop, { passive: true, signal });
          this._syncTop();
        }

        disconnectedCallback() {
          if (this._abort) this._abort.abort();
          /* Removed while the zoom is open: release the scroll lock. */
          this._unlockScroll();
        }

        /* Refcounted scroll lock shared across v2 overlays via
           html[data-shftd-locks] — counter instead of snapshot-restore, so
           stacked overlays closing in any order can never strand the page
           in overflow:hidden. */
        _lockScroll() {
          if (this._holdsLock) return;
          this._holdsLock = true;
          const html = document.documentElement;
          html.dataset.shftdLocks = String((parseInt(html.dataset.shftdLocks, 10) || 0) + 1);
          html.style.overflow = 'hidden';
        }

        _unlockScroll() {
          if (!this._holdsLock) return;
          this._holdsLock = false;
          const html = document.documentElement;
          const n = Math.max(0, (parseInt(html.dataset.shftdLocks, 10) || 1) - 1);
          if (n === 0) {
            delete html.dataset.shftdLocks;
            html.style.overflow = '';
          } else {
            html.dataset.shftdLocks = String(n);
          }
        }

        _goTo(index) {
          const item = this._items[index];
          if (!item) return;
          if (this._track.scrollWidth > this._track.clientWidth + 1) {
            this._track.scrollTo({ left: item.offsetLeft, behavior: reduced.matches ? 'auto' : 'smooth' });
          } else {
            /* Grid layout: the track doesn't scroll — the page does */
            item.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'center' });
          }
        }

        _step(dir) {
          const current = Math.round(this._track.scrollLeft / this._track.clientWidth);
          this._goTo(Math.min(this._items.length - 1, Math.max(0, current + dir)));
        }

        _syncActive() {
          const index = Math.round(this._track.scrollLeft / this._track.clientWidth);
          this._thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
        }

        _openZoom(media) {
          const zoom = this.querySelector('[data-gallery-zoom]');
          const img = this.querySelector('[data-gallery-zoom-img]');
          if (!zoom || !img || !media.dataset.zoomSrc) return;
          img.src = media.dataset.zoomSrc;
          zoom.hidden = false;
          this._lockScroll();
        }

        _closeZoom() {
          const zoom = this.querySelector('[data-gallery-zoom]');
          if (!zoom || zoom.hidden) return;
          zoom.hidden = true;
          this._unlockScroll();
        }
      }
      customElements.define('shftd-gallery', ShftdGallery);
    }

    if (!customElements.get('shftd-variant-picker')) {
      class ShftdVariantPicker extends HTMLElement {
        connectedCallback() {
          this._abort = new AbortController();
          const signal = this._abort.signal;
          const json = this.querySelector('[data-variant-json]') || document.getElementById(this.dataset.variants);
          if (!json) return;
          try {
            this._variants = JSON.parse(json.textContent);
          } catch (e) {
            return;
          }
          this._section = this.closest('.shftd-v2.pdp');
          this._groups = Array.from(this.querySelectorAll('[data-option-index]'));
          this._selected = this._groups.map((g) => {
            const btn = g.querySelector('[data-opt-btn].is-selected');
            return btn ? btn.dataset.value : null;
          });

          this.addEventListener(
            'click',
            (e) => {
              const btn = e.target.closest('[data-opt-btn]');
              if (!btn) return;
              const group = btn.closest('[data-option-index]');
              const index = parseInt(group.dataset.optionIndex, 10);
              if (this._selected[index] === btn.dataset.value) return;
              this._selected[index] = btn.dataset.value;
              group.querySelectorAll('[data-opt-btn]').forEach((b) => {
                b.classList.toggle('is-selected', b === btn);
                b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
              });
              const label = group.querySelector('[data-opt-value]');
              if (label) label.textContent = btn.dataset.value;
              this._apply();
            },
            { signal }
          );

          this._markAvailability();
        }

        disconnectedCallback() {
          if (this._abort) this._abort.abort();
        }

        _find() {
          return this._variants.find((v) => v.options.every((o, i) => o === this._selected[i])) || null;
        }

        _markAvailability() {
          this._groups.forEach((group, gi) => {
            group.querySelectorAll('[data-opt-btn]').forEach((btn) => {
              const candidate = this._selected.slice();
              candidate[gi] = btn.dataset.value;
              const ok = this._variants.some(
                (v) =>
                  v.available &&
                  v.options.every((o, i) => (i === gi ? o === btn.dataset.value : candidate[i] === null || o === candidate[i]))
              );
              btn.classList.toggle('is-unavailable', !ok);
            });
          });
        }

        /* Inventory blocks: each carries its own threshold + message template
           ([count] / [value] tokens) and follows the selected variant. */
        _syncStockNotes(variant) {
          if (!this._section) return;
          this._section.querySelectorAll('[data-stock-note]').forEach((note) => {
            const threshold = parseInt(note.dataset.threshold, 10) || 0;
            const show =
              !!variant &&
              variant.inventory_managed &&
              variant.inventory_quantity > 0 &&
              variant.inventory_quantity <= threshold;
            note.hidden = !show;
            if (show) {
              note.textContent = (note.dataset.template || '')
                .replace('[count]', variant.inventory_quantity)
                .replace('[value]', variant.options[variant.options.length - 1]);
            }
          });
        }

        _apply() {
          const variant = this._find();
          this._markAvailability();
          /* data-scope="slot": a bundle slot only reports its pick; the page's price, form, URL and gallery stay untouched. */
          if (this.dataset.scope === 'slot') {
            this.dispatchEvent(new CustomEvent('shftd:slot:change', { bubbles: true, detail: { variant } }));
            return;
          }
          const q = (sel) => (this._section ? this._section.querySelector(sel) : null);

          const atc = q('[data-atc]');
          const atcLabel = q('[data-atc-label]');
          const atcPrice = q('[data-atc-price]');
          const stickyAtc = q('[data-sticky-atc]');
          const input = q('[data-variant-input]');
          const low = q('[data-low-stock]');

          if (!variant) {
            if (atc) atc.disabled = true;
            if (atcLabel) atcLabel.textContent = this.dataset.labelUnavailable;
            if (atcPrice) atcPrice.textContent = '';
            if (stickyAtc) {
              stickyAtc.disabled = true;
              const stickyLabel = q('[data-sticky-label]');
              if (stickyLabel) stickyLabel.textContent = this.dataset.labelUnavailable;
              const stickyWrap = q('[data-sticky-entries-wrap]');
              if (stickyWrap) stickyWrap.hidden = true;
            }
            if (low) low.hidden = true;
            this._syncStockNotes(null);
            return;
          }

          if (input) input.value = variant.id;

          const priceEl = q('[data-price]');
          if (priceEl) {
            priceEl.textContent = variant.price_money;
            priceEl.classList.toggle('price--promo', !!variant.compare_at_price && variant.compare_at_price > variant.price);
          }
          const compare = q('[data-compare]');
          if (compare) {
            const onSale = !!variant.compare_at_price && variant.compare_at_price > variant.price;
            compare.hidden = !onSale;
            if (onSale) compare.textContent = variant.compare_at_price_money;
          }

          const entriesFmt = variant.entries.toLocaleString('en-US');
          const capsule = q('[data-capsule-entries]');
          if (capsule) capsule.textContent = entriesFmt;
          const stickyEntries = q('[data-sticky-entries]');
          if (stickyEntries) stickyEntries.textContent = entriesFmt;
          const stickyThumb = q('[data-sticky-thumb] img');
          if (stickyThumb && variant.media_src) stickyThumb.src = variant.media_src;
          const pillMain = q('[data-gallery-pill] .pill__main');
          if (pillMain) pillMain.textContent = entriesFmt + ' ' + this.dataset.labelEntries;

          if (atc) atc.disabled = !variant.available;
          if (atcLabel) atcLabel.textContent = variant.available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
          if (atcPrice) {
            atcPrice.textContent = variant.available ? '· ' + entriesFmt + ' ' + this.dataset.labelEntries : '';
          }
          if (stickyAtc) {
            stickyAtc.disabled = !variant.available;
            const stickyLabel = q('[data-sticky-label]');
            if (stickyLabel) stickyLabel.textContent = variant.available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
            const stickyWrap = q('[data-sticky-entries-wrap]');
            if (stickyWrap) stickyWrap.hidden = !variant.available;
          }

          if (low) {
            const threshold = parseInt(this.dataset.lowStockThreshold, 10) || 0;
            const show =
              threshold > 0 &&
              variant.inventory_managed &&
              variant.inventory_quantity > 0 &&
              variant.inventory_quantity <= threshold;
            low.hidden = !show;
            if (show) {
              low.textContent = (this.dataset.lowStockTemplate || '')
                .replace('@count@', variant.inventory_quantity)
                .replace('@value@', variant.options[variant.options.length - 1]);
            }
          }

          this._syncStockNotes(variant);

          try {
            const url = new URL(this.dataset.url, location.origin);
            url.searchParams.set('variant', variant.id);
            history.replaceState({}, '', url.pathname + url.search);
          } catch (e) {
            /* URL update is cosmetic */
          }

          if (this._section) {
            this._section.dispatchEvent(new CustomEvent('shftd:variant:change', { detail: { variant } }));
          }
        }
      }
      customElements.define('shftd-variant-picker', ShftdVariantPicker);
    }

    if (!customElements.get('shftd-product-form')) {
      class ShftdProductForm extends HTMLElement {
        /* Armed extras — the add-ons strip and any boost blocks — ride along
           with every add in the same cart/add.js call. */
        static extras() {
          const items = [];
          document.querySelectorAll('shftd-addons, shftd-boost').forEach((el) => {
            if (el.getSelectedItems) items.push.apply(items, el.getSelectedItems());
          });
          return items;
        }

        /* Posts FormData or an { items } object to cart/add.js and, on success,
           hands the refreshed cart to the pub/sub bus and the v2 cart drawer. */
        static add(body) {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const drawer = document.querySelector('shftd-cart-drawer');
          const sections = drawer && drawer.dataset.sectionId;
          const isForm = body instanceof FormData;
          if (sections) {
            if (isForm) body.append('sections', sections);
            else body.sections = sections;
          }
          const opts = isForm
            ? { method: 'POST', headers: { Accept: 'application/json' }, body }
            : {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(body),
              };

          return fetch(root + 'cart/add.js', opts)
            .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
            .then((result) => {
              if (!result.ok) return result;
              fetch(root + 'cart.js')
                .then((r) => r.json())
                .then((cart) => {
                  if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
                    window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: cart });
                  }
                  document.dispatchEvent(
                    new CustomEvent('shftd:cart:changed', {
                      detail: { cart, sections: result.data.sections || null, open: true },
                    })
                  );
                })
                .catch(() => {});
              return result;
            });
        }

        connectedCallback() {
          this._abort = new AbortController();
          const signal = this._abort.signal;
          this._form = this.querySelector('form');
          if (!this._form) return;
          this._form.addEventListener('submit', (e) => this._submit(e), { signal });
        }

        disconnectedCallback() {
          if (this._abort) this._abort.abort();
        }

        /* data-scope="bundle": the items come from the enclosing <shftd-bundle-offer>. */
        _submit(e) {
          e.preventDefault();
          const bundle = this.dataset.scope === 'bundle' ? this.closest('shftd-bundle-offer') : null;
          const items = bundle ? bundle.getItems() : null;
          if (bundle && !items) return;
          const atc = this._form.querySelector('[data-atc], [data-bundle-atc]');
          const error = this._form.querySelector('[data-form-error]');
          if (error) error.hidden = true;
          if (atc) atc.classList.add('is-busy');

          const body = new FormData(this._form);
          const extras = ShftdProductForm.extras();
          let request = body;
          if (items) {
            request = { items: items.concat(extras) };
          } else if (extras.length) {
            request = {
              items: [
                { id: parseInt(body.get('id'), 10), quantity: parseInt(body.get('quantity'), 10) || 1 },
              ].concat(extras),
            };
          }

          ShftdProductForm.add(request)
            .then(({ ok, data }) => {
              if (atc) atc.classList.remove('is-busy');
              if (!ok) {
                if (error) {
                  error.textContent = data.description || data.message || '';
                  error.hidden = !error.textContent;
                }
                return;
              }
              if (atc) {
                atc.classList.add('is-added');
                setTimeout(() => atc.classList.remove('is-added'), 1600);
              }
            })
            .catch(() => {
              if (atc) atc.classList.remove('is-busy');
              if (error) {
                error.textContent = this.dataset.labelError || 'Error';
                error.hidden = false;
              }
            });
        }
      }
      customElements.define('shftd-product-form', ShftdProductForm);
    }

    if (!customElements.get('shftd-boost')) {
      /* Toggle model, same as the add-ons strip: + arms the boost (check
         icon), reclick disarms. Nothing touches the cart here — the product
         form collects getSelectedItems() when the main add-to-cart fires,
         and the block resets on 'shftd:cart:changed'. */
      class ShftdBoost extends HTMLElement {
        connectedCallback() {
          this._abort = new AbortController();
          const signal = this._abort.signal;
          this._btn = this.querySelector('[data-boost-add]');
          if (!this._btn) return;

          this._btn.addEventListener(
            'click',
            () => {
              const on = !this._btn.classList.contains('is-selected');
              this._btn.classList.toggle('is-selected', on);
              this._btn.setAttribute('aria-pressed', on ? 'true' : 'false');
            },
            { signal }
          );

          /* The main add-to-cart fired and took the armed boost with it */
          document.addEventListener('shftd:cart:changed', () => this.clearSelected(), { signal });
        }

        disconnectedCallback() {
          if (this._abort) this._abort.abort();
        }

        getSelectedItems() {
          if (!this._btn || !this._btn.classList.contains('is-selected')) return [];
          const id = parseInt(this._btn.dataset.variantId, 10);
          return id ? [{ id, quantity: 1 }] : [];
        }

        clearSelected() {
          if (!this._btn) return;
          this._btn.classList.remove('is-selected');
          this._btn.setAttribute('aria-pressed', 'false');
        }
      }
      customElements.define('shftd-boost', ShftdBoost);
    }

    if (!customElements.get('shftd-bundle-offer')) {
      const SINGLE_ONLY = '.pdp__picker, .pdp__buybox, .pdp__stock, .pdp__capsule';

      class ShftdBundleOffer extends HTMLElement {
        connectedCallback() {
          const json = this.querySelector('[data-bundle-json]');
          if (!json) return;
          try {
            this._variants = JSON.parse(json.textContent);
          } catch (e) {
            return;
          }
          this._abort = new AbortController();
          const signal = this._abort.signal;
          this._section = this.closest('.pdp');
          /* No switch rendered = bundle-only (show_single off). */
          const switcher = this.querySelector('[data-bundle-switch]');
          this._views = switcher ? Array.from(switcher.querySelectorAll('[data-bundle-view]')) : [];
          this._radio = Boolean(switcher) && switcher.getAttribute('role') === 'radiogroup';
          this._switchValue = switcher && switcher.querySelector('[data-bundle-switch-value]');
          this._panel = this.querySelector('[data-bundle-panel]');
          this._atc = this.querySelector('[data-bundle-atc]');
          const scope = this._section || this;
          this._progress = scope.querySelectorAll('[data-bundle-progress]');
          this._count = scope.querySelectorAll('[data-bundle-count]');
          this._kit = this.dataset.mode === 'kit';
          this._free = parseInt(this.dataset.free, 10) || 0;
          this._entries = this._section ? this._section.querySelectorAll('[data-bundle-entries]') : [];
          this._sticky = scope.querySelectorAll('[data-sticky-bundle-btn]');
          this._stickyAtc = scope.querySelector('[data-sticky-bundle-atc]');
          const wrap = this._section && this._section.querySelector('[data-price-wrap]');
          this._price = wrap && wrap.querySelector('[data-price]');
          this._compare = wrap && wrap.querySelector('[data-compare]');
          this._single = null;

          /* Each slot prices from its own product's variants (bundle items), or the page product's. */
          const lists = {};
          const variantsOf = (id) => {
            if (!id || id === json.id) return this._variants;
            if (!lists[id]) {
              const el = document.getElementById(id);
              try {
                lists[id] = el ? JSON.parse(el.textContent) : [];
              } catch (e) {
                lists[id] = [];
              }
            }
            return lists[id];
          };
          this._slots = Array.from(this.querySelectorAll('[data-bundle-slot]')).map((el) => {
            const variants = variantsOf(el.dataset.variants);
            const available = variants.filter((v) => v.available);
            const lowest = (list) => list.reduce((min, v) => (!min || v.price < min.price ? v : min), null);
            const cheapest = lowest(available) || lowest(variants);
            return {
              el,
              cheapest,
              minPriceMoney: (lowest(variants) || {}).price_money || '',
              variant: el.querySelector('shftd-variant-picker') ? null : available[0] || null,
              size: el.hasAttribute('data-sized') ? null : '',
            };
          });

          if (this._kit) {
            this.addEventListener(
              'click',
              (e) => {
                const btn = e.target.closest('[data-kit-size]');
                if (btn) this._pickSize(btn);
              },
              { signal }
            );
          }
          this._sticky.forEach((btn) => btn.addEventListener('click', () => this._stickyAdd(), { signal }));
          this.addEventListener(
            'click',
            (e) => {
              const btn = e.target.closest('[data-slot-edit]');
              if (!btn) return;
              const slot = this._slots.find((s) => s.el.contains(btn));
              this._collapse(slot, false);
              const first = slot.el.querySelector('.bundle-slot__picker button');
              if (first) first.focus();
            },
            { signal }
          );

          if (switcher) {
            switcher.addEventListener(
              'click',
              (e) => {
                const btn = e.target.closest('[data-bundle-view]');
                if (btn) this._select(btn.dataset.bundleView);
              },
              { signal }
            );
            switcher.addEventListener('keydown', (e) => this._onKey(e), { signal });
          }
          this.addEventListener(
            'shftd:slot:change',
            (e) => {
              const slot = this._slots.find((s) => s.el.contains(e.target));
              const variant = e.detail.variant;
              slot.variant = variant && variant.available ? variant : null;
              this._thumb(slot);
              if (slot.variant) this._collapse(slot, true);
              this._render();
            },
            { signal }
          );

          if (this._section) {
            /* A Single pick while Bundle is showing: keep its price as the restore point, then re-apply the bundle total. */
            this._section.addEventListener(
              'shftd:variant:change',
              () => {
                if (!this._single) return;
                this._single = this._snapshot();
                this._render();
              },
              { signal }
            );
            this._section.addEventListener(
              'shopify:block:select',
              (e) => {
                if (e.target === this) this._select('bundle');
                else if (switcher && e.target.closest(SINGLE_ONLY)) this._select('single');
              },
              { signal }
            );
          }

          if (!this._kit) this._slots.forEach((slot) => this._thumb(slot));
          const view = new URLSearchParams(location.search).get('pack');
          if (!switcher) this._select('bundle');
          else this._select(view === 'bundle' || view === 'single' ? view : this._section ? this._section.dataset.pdpView : 'single');
        }

        disconnectedCallback() {
          if (this._abort) this._abort.abort();
        }

        _select(view) {
          this._views.forEach((btn) => {
            const on = btn.dataset.bundleView === view;
            btn.setAttribute(this._radio ? 'aria-checked' : 'aria-selected', String(on));
            btn.tabIndex = on ? 0 : -1;
            if (this._radio) btn.classList.toggle('is-selected', on);
            if (on && this._switchValue) this._switchValue.textContent = btn.dataset.label;
          });
          this._panel.hidden = view !== 'bundle';
          if (this._section) this._section.dataset.pdpView = view;
          document.dispatchEvent(new CustomEvent('shftd:pdp:view', { detail: { view } }));
          if (view === 'bundle' && !this._single) this._single = this._snapshot();
          if (view !== 'bundle' && this._single) {
            this._restore(this._single);
            this._single = null;
          }
          this._render();
        }

        _snapshot() {
          if (!this._price) return {};
          return {
            price: this._price.textContent,
            priceClass: this._price.className,
            compare: this._compare ? this._compare.textContent : '',
            compareHidden: this._compare ? this._compare.hidden : true,
          };
        }

        _restore(state) {
          if (!this._price) return;
          this._price.textContent = state.price;
          this._price.className = state.priceClass;
          if (this._compare) {
            this._compare.textContent = state.compare;
            this._compare.hidden = state.compareHidden;
          }
        }

        _onKey(e) {
          const i = this._views.indexOf(document.activeElement);
          const last = this._views.length - 1;
          const forward = i === last ? 0 : i + 1;
          const back = i === 0 ? last : i - 1;
          const keys = { ArrowRight: forward, ArrowLeft: back, Home: 0, End: last };
          if (this._radio) Object.assign(keys, { ArrowDown: forward, ArrowUp: back });
          const next = keys[e.key];
          if (i < 0 || next === undefined) return;
          e.preventDefault();
          this._select(this._views[next].dataset.bundleView);
          this._views[next].focus();
        }

        _thumb(slot) {
          const img = slot.el.querySelector('[data-slot-img]');
          const v = slot.variant;
          const fallback = slot.el.hasAttribute('data-own-product') ? '' : this.dataset.fallbackSrc;
          const src = v && (v.media_src || fallback);
          if (src) {
            img.src = src;
            img.alt = v.media_src ? v.media_alt : this.dataset.fallbackAlt;
          }
          img.hidden = !src;
        }

        _pickSize(btn) {
          const slot = this._slots.find((s) => s.el.contains(btn));
          slot.size = btn.dataset.value;
          slot.el.querySelectorAll('[data-kit-size]').forEach((b) => {
            const on = b === btn;
            b.classList.toggle('is-selected', on);
            b.setAttribute('aria-pressed', String(on));
          });
          const value = slot.el.querySelector('[data-kit-value]');
          if (value) value.textContent = slot.size;
          this._collapse(slot, true);
          this._render();
        }

        /* A picked slot folds to a one-line summary ("Color · Black") with an edit button that reopens its options. */
        _collapse(slot, on) {
          const summary = slot.el.querySelector('[data-slot-summary]');
          const picker = slot.el.querySelector('.bundle-slot__picker');
          if (!summary || !picker) return;
          if (on) {
            const parts = Array.from(picker.querySelectorAll('.pdp__opt-head .lbl')).map((l) =>
              l.textContent.replace(/\s+/g, ' ').trim()
            );
            summary.querySelector('[data-slot-summary-text]').textContent = parts.join(' / ');
          }
          summary.hidden = !on;
          picker.hidden = on;
        }

        /* data-sequential: items needing a pick unlock in order, each waiting on the one before it. */
        _lock() {
          if (!this.hasAttribute('data-sequential')) return;
          let open = true;
          this._slots.forEach((s) => {
            const needsPick = this._kit ? s.size !== '' : Boolean(s.el.querySelector('shftd-variant-picker'));
            if (!needsPick) return;
            s.el.classList.toggle('is-locked', !open);
            if (open) s.el.removeAttribute('aria-disabled');
            else s.el.setAttribute('aria-disabled', 'true');
            if (!this._isDone(s)) open = false;
          });
        }

        _isDone(slot) {
          return this._kit ? slot.size !== null : Boolean(slot.variant);
        }

        /* Sticky Add bundle: adds when every item is picked, otherwise brings the first open item into view. */
        _stickyAdd() {
          const open = this._slots.find((s) => !this._isDone(s));
          if (!open) {
            this._atc.form.requestSubmit();
            return;
          }
          open.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const first = open.el.querySelector('button');
          if (first) first.focus({ preventScroll: true });
        }

        _render() {
          if (this._kit) {
            const sized = this._slots.filter((s) => s.size !== '');
            const done = sized.filter((s) => s.size !== null).length;
            this._lock();
            const ready = done === sized.length;
            this._progressTo(done, ready);
            return;
          }
          const done = this._slots.filter((s) => s.variant).length;
          const ready = done === this._slots.length;
          this._lock();
          const priced = this._slots.map((slot, index) => ({ slot, index, variant: slot.variant || slot.cheapest }));
          const sum = (list, key) => list.reduce((total, p) => total + p.variant[key], 0);
          /* Buy X get Y free: the cheapest items (unpicked ones at their cheapest variant) show free; ties go to the later item. */
          const free = new Set(
            priced
              .slice()
              .sort((a, b) => a.variant.price - b.variant.price || b.index - a.index)
              .slice(0, this._free)
              .map((p) => p.slot)
          );

          this._progressTo(done, ready);
          const entries = sum(priced, 'entries').toLocaleString('en-US');
          this._entries.forEach((el) => (el.textContent = entries));
          if (this._single && this._price) {
            this._price.textContent = this._money(sum(priced.filter((p) => !free.has(p.slot)), 'price'));
            this._price.classList.toggle('price--promo', free.size > 0);
            if (this._compare) {
              this._compare.textContent = this._money(sum(priced, 'price'));
              this._compare.hidden = free.size === 0;
            }
          }

          this._slots.forEach((s) => {
            const isFree = free.has(s);
            const price = s.el.querySelector('[data-slot-price]');
            const compare = s.el.querySelector('[data-slot-compare]');
            const from = s.el.querySelector('[data-slot-from]');
            if (compare) {
              compare.textContent = (s.variant || s.cheapest).price_money;
              compare.hidden = !isFree;
            }
            if (isFree) price.textContent = this.dataset.freeText || this._money(0);
            else price.textContent = s.variant ? s.variant.price_money : s.minPriceMoney;
            price.classList.toggle('price--promo', isFree);
            if (from) from.hidden = Boolean(s.variant) || isFree;
          });
        }

        /* The in-panel and sticky "0/3 selected" swap for their Add bundle buttons once every item is picked. */
        _progressTo(done, ready) {
          this._count.forEach((el) => (el.textContent = done));
          this._progress.forEach((el) => (el.hidden = ready));
          this._atc.disabled = !ready;
          this._atc.hidden = !ready;
          if (this._stickyAtc) this._stickyAtc.hidden = !ready;
        }

        _money(cents) {
          const digits = Number(this.dataset.moneyDecimals);
          const amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
          return this.dataset.moneyTemplate.replace('[amount]', amount);
        }

        getItems() {
          if (!this._slots || this._slots.some((s) => !this._isDone(s))) return null;
          if (this._kit) {
            /* Same line properties as the v1 kit block, which production expansion reads. */
            const properties = { _bundle: 'kit' };
            this._slots.forEach((s) => {
              if (s.size) properties[s.el.dataset.piece + ' size'] = s.size;
            });
            return [{ id: parseInt(this.dataset.kitVariant, 10), quantity: 1, properties }];
          }
          return this._slots.map((s) => ({ id: s.variant.id, quantity: 1 }));
        }
      }
      customElements.define('shftd-bundle-offer', ShftdBundleOffer);
    }

    /* Sticky bar: visible while the real buy box is off screen. While active,
       the page gets matching bottom padding so the bar never covers the
       footer at the end of the page. */
    /* Each bar (single, and bundle when the offer renders) tracks its own
       buy row; the inactive view's bar is display: none, so it adds no space.
       A custom element so a theme-editor section re-render re-observes. */
    if (!customElements.get('shftd-sticky-bar')) {
      const syncBarSpace = () => {
        const active = Array.from(document.querySelectorAll('shftd-sticky-bar.is-active')).find((b) => b.offsetHeight);
        document.body.style.paddingBottom = active ? active.offsetHeight + 'px' : '';
        document.body.style.setProperty('--pdp-stickybar-h', active ? active.offsetHeight + 'px' : '0px');
      };

      class ShftdStickyBar extends HTMLElement {
        connectedCallback() {
          const scope = this.closest('.pdp') || document;
          const target = scope.querySelector(this.dataset.stickyTarget);
          this._abort = new AbortController();
          const signal = this._abort.signal;
          window.addEventListener('resize', syncBarSpace, { passive: true, signal });
          document.addEventListener('shftd:pdp:view', syncBarSpace, { signal });
          if (target && 'IntersectionObserver' in window) {
            this._io = new IntersectionObserver(
              (entries) => {
                this.classList.toggle('is-active', !entries[0].isIntersecting);
                syncBarSpace();
              },
              { rootMargin: '-80px 0px 0px 0px' }
            );
            this._io.observe(target);
          } else {
            this.classList.add('is-active');
            syncBarSpace();
          }
        }

        disconnectedCallback() {
          if (this._io) this._io.disconnect();
          if (this._abort) this._abort.abort();
          syncBarSpace();
        }
      }
      customElements.define('shftd-sticky-bar', ShftdStickyBar);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-countdown')) {
    // One shared 1s clock: the repeat and the clone can put 16 identical
    // countdowns in the DOM, and 16 intervals would all compute the same string.
    const live = new Set();
    let clock = null;

    const startClock = () => {
      if (clock === null) {
        clock = window.setInterval(() => {
          // Snapshot, because an expiring countdown removes itself in _tick.
          Array.from(live).forEach((el) => el._tick());
        }, 1000);
      }
    };

    const stopClockIfIdle = () => {
      if (clock !== null && live.size === 0) {
        window.clearInterval(clock);
        clock = null;
      }
    };

    class ShftdCountdown extends HTMLElement {
      connectedCallback() {
        // The editor can move a section's DOM and re-run this callback.
        this._stop();

        this._out = this.querySelector('.marquee-v2__clock-out');
        if (!this._out) return;

        // Bail silently so the server-rendered `--:--:--` stays on screen.
        const epoch = parseInt(this.dataset.targetEpoch, 10);
        if (isNaN(epoch) || epoch <= 0) return;

        this._onEnded = this.dataset.onEnded || 'text';

        this._target = epoch * 1000;
        this._done = false;

        // Before first paint, so an expired band never flashes on screen.
        this._tick();

        // An already-expired countdown must not re-enter the shared clock.
        if (!this._done) {
          live.add(this);
          startClock();
        }
      }

      disconnectedCallback() {
        this._stop();
      }

      _stop() {
        live.delete(this);
        stopClockIfIdle();
      }

      _expire() {
        this._done = true;

        if (this._onEnded === 'hide_item') {
          const item = this.closest('.marquee-v2__item');
          if (item) item.classList.add('is-ended-hidden');
        } else {
          // The ended text replaces the item's WHOLE text, not just the clock:
          // prefix and suffix wrap a running number ("Boost ends in 02:18:57"),
          // so keeping them would leave "Boost ends in Closed". Both are
          // siblings of this element, so hide them via the item root rather
          // than writing over them, so the markup stays intact for the editor,
          // which re-renders the section on every settings change.
          const item = this.closest('.marquee-v2__item');
          if (item) item.classList.add('is-ended');
          this._out.textContent = this.dataset.endedText;
        }

        this._stop();

        // Removing an item changes the track's width but not the viewport's,
        // so the ResizeObserver never fires.
        if (this._onEnded === 'hide_item') {
          this.dispatchEvent(
            new CustomEvent('shftd-marquee:refresh', { bubbles: true })
          );
        }
      }

      _tick() {
        const remaining = this._target - Date.now();
        if (remaining <= 0) {
          this._expire();
          return;
        }
        const total = Math.floor(remaining / 1000);
        const days = Math.floor(total / 86400);
        const hours = Math.floor((total % 86400) / 3600);
        const minutes = Math.floor((total % 3600) / 60);
        const seconds = total % 60;
        const pad = (n) => String(n).padStart(2, '0');
        // Days roll out front rather than letting hours run to 7600:12:03.
        const clock = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
        this._out.textContent = days > 0 ? days + 'D ' + clock : clock;
      }
    }
    customElements.define('shftd-countdown', ShftdCountdown);
  }

  if (!customElements.get('shftd-marquee')) {
    class ShftdMarquee extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this._track = this.querySelector('.marquee-v2__track');
        this._copy = this.querySelector('.marquee-v2__copy');
        if (!this._track || !this._copy) return;

        // Read once to avoid a style recalc on every resize.
        const styles = getComputedStyle(this);
        this._speed = parseFloat(styles.getPropertyValue('--speed')) || 60;

        // NaN means "no hover behaviour"; 0 means stop, so no falsy check.
        this._hoverSpeed = parseFloat(styles.getPropertyValue('--hover-speed'));
        this._bindHover();

        this._refresh = () => {
          this._lastWidth = undefined;
          this._measure();
          this._hideIfEmpty();
        };
        this.addEventListener('shftd-marquee:refresh', this._refresh);

        this._measure();

        // Webfonts change the copy's width after first paint, and the observer
        // below won't catch it: the viewport's own box is unchanged.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this._measure());
        }

        if ('ResizeObserver' in window) {
          this._ro = new ResizeObserver(() => {
            window.clearTimeout(this._debounce);
            this._debounce = window.setTimeout(() => this._measure(), 150);
          });
          this._ro.observe(this);
        }
      }

      disconnectedCallback() {
        if (this._ro) {
          this._ro.disconnect();
          this._ro = null;
        }
        window.clearTimeout(this._debounce);

        if (this._refresh) {
          this.removeEventListener('shftd-marquee:refresh', this._refresh);
          this._refresh = null;
        }

        if (this._enter) {
          this.removeEventListener('mouseenter', this._enter);
          this.removeEventListener('focusin', this._enter);
          this.removeEventListener('mouseleave', this._leave);
          this.removeEventListener('focusout', this._leave);
          this._enter = null;
          this._leave = null;
        }
      }

      _bindHover() {
        if (Number.isNaN(this._hoverSpeed)) return;
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

        this._enter = () => this._setRate(this._hoverSpeed / this._speed);
        this._leave = () => this._setRate(1);

        this.addEventListener('mouseenter', this._enter);
        this.addEventListener('mouseleave', this._leave);
        this.addEventListener('focusin', this._enter);
        this.addEventListener('focusout', this._leave);
      }

      _hideIfEmpty() {
        // Every item expired, and an empty strip reads as broken. Not in
        // the editor though: dropping the section there would take away the one
        // the merchant is configuring.
        if (window.Shopify && window.Shopify.designMode) return;

        const remaining = this._copy.querySelector(
          '.marquee-v2__item:not(.is-ended-hidden)'
        );
        if (remaining) return;

        const root = this.closest('.marquee-v2');
        if (root) root.classList.add('is-ended-hidden');
      }

      _setRate(rate) {
        // playbackRate rescales in place; rewriting the duration would snap the
        // track back to the start.
        if (!this._track.getAnimations) return;
        const animations = this._track.getAnimations();
        for (let n = 0; n < animations.length; n += 1) {
          animations[n].playbackRate = rate;
        }
      }

      _measure() {
        const width = this._copy.getBoundingClientRect().width;
        if (!width) return;

        // A duration rewrite makes the track jump (the elapsed time is kept,
        // so the progress fraction changes), and mobile address-bar show/hide
        // fires resize constantly — skip no-op measures.
        if (this._lastWidth !== undefined && Math.abs(width - this._lastWidth) < 1) return;
        this._lastWidth = width;

        // Capture the current progress BEFORE rewriting the duration, then
        // re-seat the animation at the same fraction of the new duration so
        // the change is invisible instead of a visible jump.
        const durS = width / this._speed;
        let anim = null;
        let fraction = 0;
        if (this._track.getAnimations) {
          anim = this._track.getAnimations()[0] || null;
          if (anim && anim.effect && anim.effect.getComputedTiming) {
            const timing = anim.effect.getComputedTiming();
            if (typeof timing.progress === 'number') fraction = timing.progress;
          }
        }

        this._track.style.setProperty('--marquee-dur', durS.toFixed(2) + 's');
        if (anim) anim.currentTime = fraction * durS * 1000;
      }
    }
    customElements.define('shftd-marquee', ShftdMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motorcycle-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const galleries = document.querySelectorAll('.motorcycle-gallery');
  
  galleries.forEach(gallery => {
    const mainImage = gallery.querySelector('[data-main-image]');
    const mainImageContainer = gallery.querySelector('[data-main-image-container]');
    const thumbnailsContainer = gallery.querySelector('[data-thumbnails-container]');
    const thumbnails = gallery.querySelectorAll('.motorcycle-gallery__thumbnail-wrapper');
    const prevButtons = gallery.querySelectorAll('[data-nav="prev"]');
    const nextButtons = gallery.querySelectorAll('[data-nav="next"]');
    
    let currentIndex = 0;
    const thumbnailWidth = thumbnails[0].offsetWidth + 15; // Include gap
    const visibleThumbnails = Math.floor(thumbnailsContainer.offsetWidth / thumbnailWidth);
    const maxIndex = thumbnails.length - 1;
    const maxScroll = Math.max(0, thumbnails.length - visibleThumbnails);
    
    // Initialize nav buttons state
    updateNavButtons();
    
    // Handle thumbnail clicks
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', function() {
        updateMainImage(index);
      });
    });
    
    // Navigation buttons - both main and thumbnail nav
    prevButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Loop to the last item if at beginning
        const newIndex = currentIndex <= 0 ? maxIndex : currentIndex - 1;
        updateMainImage(newIndex);
      });
    });
    
    nextButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Loop to the first item if at end
        const newIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
        updateMainImage(newIndex);
      });
    });
    
    function updateMainImage(index) {
      const thumbnail = thumbnails[index];
      const imageUrl = thumbnail.getAttribute('data-image-url');
      const caption = thumbnail.getAttribute('data-caption');
      
      // Update active state
      thumbnails.forEach(thumb => thumb.classList.remove('active'));
      thumbnail.classList.add('active');
      currentIndex = index;
      
      // Update main image with fade effect
      mainImage.style.opacity = '0';
      setTimeout(() => {
        mainImage.src = imageUrl;
        mainImage.style.opacity = '1';
        
        // Update caption
        const captionElement = mainImageContainer.querySelector('.motorcycle-gallery__caption');
        if (captionElement) {
          captionElement.textContent = caption;
        } else if (caption) {
          const newCaption = document.createElement('div');
          newCaption.className = 'motorcycle-gallery__caption';
          newCaption.textContent = caption;
          mainImageContainer.appendChild(newCaption);
        }
      }, 300);
      
      // Ensure clicked thumbnail is visible in carousel
      ensureThumbnailVisible(index);
    }
    
    function scrollThumbnails(index) {
      // Implement looping behavior for thumbnails too
      let scrollIndex = index;
      
      if (index < 0) {
        // If scrolling before the first item, wrap to end
        scrollIndex = maxScroll;
      } else if (index > maxScroll) {
        // If scrolling past the last visible set, wrap to beginning
        scrollIndex = 0;
      }
      
      const scrollPosition = -scrollIndex * thumbnailWidth;
      thumbnailsContainer.style.transform = `translateX(${scrollPosition}px)`;
      
      return scrollIndex;
    }
    
    function ensureThumbnailVisible(index) {
      // Calculate current visible range
      const firstVisible = Math.abs(parseInt(thumbnailsContainer.style.transform.replace('translateX(', '').replace('px)', '') || 0)) / thumbnailWidth;
      const lastVisible = firstVisible + visibleThumbnails - 1;
      
      if (index < firstVisible) {
        // Scroll back to make this thumbnail visible
        scrollThumbnails(index);
      } else if (index > lastVisible) {
        // Scroll forward to make this thumbnail visible
        scrollThumbnails(index - visibleThumbnails + 1);
      } else if (index === 0 && firstVisible > 0) {
        // If selecting the first image but we're scrolled
        scrollThumbnails(0);
      } else if (index === maxIndex && lastVisible < maxIndex) {
        // If selecting the last image but it's not fully visible
        scrollThumbnails(maxScroll);
      }
    }
    
    function updateNavButtons() {
      // With looping behavior, buttons are always enabled
      // This function is kept for potential future use
    }
    
    // Handle keyboard navigation
    gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        const newIndex = currentIndex <= 0 ? maxIndex : currentIndex - 1;
        updateMainImage(newIndex);
      } else if (e.key === 'ArrowRight') {
        const newIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
        updateMainImage(newIndex);
      }
    });
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Recalculate visible thumbnails
        const newVisibleThumbnails = Math.floor(thumbnailsContainer.offsetWidth / thumbnailWidth);
        if (newVisibleThumbnails !== visibleThumbnails) {
          // Reset position to ensure current thumbnail is visible
          ensureThumbnailVisible(currentIndex);
        }
      }, 250);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motorcycle-specs-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Tab functionality
  const tabButtons = document.querySelectorAll('.motorcycle-specs-showcase__tab-button');
  const tabContents = document.querySelectorAll('.motorcycle-specs-showcase__tab-content');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Remove active class from all buttons and content
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
      
      // Add active class to clicked button and corresponding content
      button.classList.add('active');
      const tabId = button.getAttribute('data-tab');
      document.querySelector(`[data-tab-content="${tabId}"]`).classList.add('active');
    });
  });
  
  // 3D tilt effect using vanilla JS (simpler version of tilt.js)
  const modelWrapper = document.querySelector('.motorcycle-specs-showcase__model-wrapper');
  if (modelWrapper) {
    const maxTilt = parseFloat(modelWrapper.getAttribute('data-tilt-max') || '5');
    const perspective = parseFloat(modelWrapper.getAttribute('data-tilt-perspective') || '1000');
    
    // Apply initial 3D perspective
    modelWrapper.style.transformStyle = 'preserve-3d';
    modelWrapper.style.perspective = `${perspective}px`;
    
    // Handle mouse movement
    modelWrapper.addEventListener('mousemove', function(e) {
      const rect = modelWrapper.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      // Calculate rotation based on mouse position
      const rotateY = maxTilt * (e.clientX - centerX) / (rect.width / 2);
      const rotateX = -maxTilt * (e.clientY - centerY) / (rect.height / 2);
      
      // Apply transform
      modelWrapper.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      
      // Move image slightly forward for 3D effect
      const image = modelWrapper.querySelector('.motorcycle-specs-showcase__image');
      if (image) {
        image.style.transform = `translateZ(20px)`;
      }
    });
    
    // Reset on mouse leave
    modelWrapper.addEventListener('mouseleave', function() {
      modelWrapper.style.transform = 'rotateX(0) rotateY(0)';
      
      const image = modelWrapper.querySelector('.motorcycle-specs-showcase__image');
      if (image) {
        image.style.transform = 'translateZ(0)';
      }
    });
    
    // Mobile controls for rotation
    const leftBtn = document.querySelector('.motorcycle-specs-showcase__control--left');
    const rightBtn = document.querySelector('.motorcycle-specs-showcase__control--right');
    let currentRotation = 0;
    
    if (leftBtn && rightBtn) {
      leftBtn.addEventListener('click', function() {
        currentRotation -= 30;
        modelWrapper.querySelector('.motorcycle-specs-showcase__model').style.transform = `rotateY(${currentRotation}deg)`;
      });
      
      rightBtn.addEventListener('click', function() {
        currentRotation += 30;
        modelWrapper.querySelector('.motorcycle-specs-showcase__model').style.transform = `rotateY(${currentRotation}deg)`;
      });
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-addons-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-addons')) {
    /* Toggle model: + arms an add-on (check icon), reclick disarms. Products
       with variants open a picker popover first. Nothing touches the cart
       here — the product form collects getSelectedItems() when the main
       add-to-cart fires, and the strip resets on 'shftd:cart:changed'. */
    class ShftdAddons extends HTMLElement {
      connectedCallback() {
        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._status = this.querySelector('[data-addons-status]');
        this._selected = new Map();
        this._pop = null;

        this.addEventListener(
          'click',
          (e) => {
            const btn = e.target.closest('[data-addon-add]');
            if (!btn) return;
            e.preventDefault();
            if (btn.classList.contains('is-selected')) {
              this._deselect(btn);
            } else if (btn.dataset.variants) {
              this._openPop(btn);
            } else {
              this._select(btn, parseInt(btn.dataset.variantId, 10));
            }
          },
          { signal }
        );

        /* Capture-phase outside click: popover buttons are excluded so their
           own click handlers still run. */
        document.addEventListener(
          'click',
          (e) => {
            if (this._pop && !e.target.closest('.padd__pop') && !e.target.closest('[data-addon-add]')) {
              this._closePop();
            }
          },
          { signal, capture: true }
        );
        document.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'Escape') this._closePop();
          },
          { signal }
        );
        /* Keep the popover anchored while anything scrolls or resizes;
           close it only once its button leaves the viewport. */
        document.addEventListener('scroll', () => this._placePop(), { signal, passive: true, capture: true });
        window.addEventListener('resize', () => this._placePop(), { signal, passive: true });

        /* The main add-to-cart fired and took the armed add-ons with it */
        document.addEventListener('shftd:cart:changed', () => this.clearSelected(), { signal });
      }

      disconnectedCallback() {
        if (this._abort) this._abort.abort();
        this._closePop();
      }

      getSelectedItems() {
        return Array.from(this._selected.values()).map((id) => ({ id, quantity: 1 }));
      }

      clearSelected() {
        this._selected.forEach((_, btn) => {
          btn.classList.remove('is-selected');
          btn.setAttribute('aria-pressed', 'false');
        });
        this._selected.clear();
        this._syncStatus();
      }

      _select(btn, variantId) {
        this._selected.set(btn, variantId);
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        this._closePop();
        this._syncStatus();
      }

      _deselect(btn) {
        this._selected.delete(btn);
        btn.classList.remove('is-selected');
        btn.setAttribute('aria-pressed', 'false');
        this._syncStatus();
      }

      _syncStatus() {
        if (!this._status) return;
        const count = this._selected.size;
        if (count > 0) {
          const template = count === 1 ? this.dataset.addedOne : this.dataset.addedOther;
          this._status.textContent = (template || '@count@ added').replace('@count@', count);
        } else {
          this._status.textContent = this.dataset.addedNone;
        }
      }

      /* Option-group picker, same interaction as the product page: one row
         of value buttons per option; a complete available selection resolves
         the variant, arms the row and closes the popover. */
      _openPop(btn) {
        this._closePop();
        let data;
        try {
          data = JSON.parse(btn.dataset.variants);
        } catch (err) {
          return;
        }
        const names = data.options || [];
        const variants = data.variants || [];
        const sel = names.map(() => null);
        const groups = [];

        const markAvailability = () => {
          groups.forEach((group, gi) => {
            group.buttons.forEach((valueBtn) => {
              const ok = variants.some(
                (v) =>
                  v.available &&
                  v.options.every((o, i) => (i === gi ? o === valueBtn.dataset.value : sel[i] === null || o === sel[i]))
              );
              valueBtn.classList.toggle('is-unavailable', !ok);
            });
          });
        };

        const resolve = () => {
          if (sel.some((s) => s === null)) return;
          const match = variants.find((v) => v.available && v.options.every((o, i) => o === sel[i]));
          if (match) this._select(btn, match.id);
        };

        const pop = document.createElement('div');
        pop.className = 'shftd-v2 padd__pop';
        names.forEach((name, gi) => {
          const group = document.createElement('div');
          group.className = 'padd__pop-group';
          const label = document.createElement('span');
          label.className = 'lbl';
          label.textContent = name;
          const values = document.createElement('div');
          values.className = 'padd__pop-values';
          const seen = [];
          variants.forEach((v) => {
            if (!seen.includes(v.options[gi])) seen.push(v.options[gi]);
          });
          const buttons = seen.map((value) => {
            const valueBtn = document.createElement('button');
            valueBtn.type = 'button';
            valueBtn.className = 'optbtn';
            valueBtn.dataset.value = value;
            valueBtn.textContent = value;
            valueBtn.setAttribute('aria-pressed', 'false');
            valueBtn.addEventListener('click', () => {
              sel[gi] = value;
              buttons.forEach((b) => {
                b.classList.toggle('is-selected', b === valueBtn);
                b.setAttribute('aria-pressed', b === valueBtn ? 'true' : 'false');
              });
              markAvailability();
              resolve();
            });
            values.appendChild(valueBtn);
            return valueBtn;
          });
          groups.push({ buttons });
          group.append(label, values);
          pop.appendChild(group);
        });
        markAvailability();

        document.body.appendChild(pop);
        this._pop = pop;
        this._popBtn = btn;
        this._placePop();
      }

      /* Fit-aware placement: below the button and right-aligned by default,
         flipped above when the bottom would overflow, clamped into the
         viewport horizontally. Re-run on every scroll/resize. */
      _placePop() {
        if (!this._pop || !this._popBtn) return;
        const margin = 8;
        const rect = this._popBtn.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight || rect.right < 0 || rect.left > window.innerWidth) {
          this._closePop();
          return;
        }
        const popRect = this._pop.getBoundingClientRect();
        let top = rect.bottom + 6;
        if (top + popRect.height > window.innerHeight - margin) {
          const above = rect.top - 6 - popRect.height;
          top = above >= margin ? above : Math.max(margin, window.innerHeight - margin - popRect.height);
        }
        const left = Math.min(
          Math.max(margin, rect.right - popRect.width),
          window.innerWidth - margin - popRect.width
        );
        this._pop.style.top = Math.round(top) + 'px';
        this._pop.style.left = Math.round(left) + 'px';
      }

      _closePop() {
        if (this._pop) {
          this._pop.remove();
          this._pop = null;
          this._popBtn = null;
        }
      }
    }
    customElements.define('shftd-addons', ShftdAddons);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["progress-bar-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-progress-v2')) {
    class ShftdProgressV2 extends HTMLElement {
      connectedCallback() {
        // Re-render in the theme editor reconnects the element: start clean so
        // the fill replays from zero instead of inheriting a stale state.
        this.classList.remove('is-armed', 'is-in');
        if (this._io) this._io.disconnect();
        this._io = null;

        if (!this.hasAttribute('data-animate')) return;
        if (!('IntersectionObserver' in window)) return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        // Park the fill at 0 and commit that style before observing, so the
        // transition to the real width has a start value to run from.
        this.classList.add('is-armed');
        void this.offsetWidth;

        this._io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.classList.add('is-in');
            if (this._io) this._io.disconnect();
            this._io = null;
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        this._io.observe(this);
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        this._io = null;
      }
    }
    customElements.define('shftd-progress-v2', ShftdProgressV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shftd-subcol')) {
    class ShftdSubcol extends HTMLElement {
      connectedCallback() {
        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._track = this.querySelector('[data-subcol-track]');
        if (!this._track) return;

        if (this.hasAttribute('data-auto-active')) this._refineActive();

        if (this.hasAttribute('data-sticky')) {
          this._syncStickyTop = () => {
            const wrap = this.closest('.shopify-section') || this;
            let top = 0;
            document.querySelectorAll('.shopify-section').forEach((sec) => {
              if (sec === wrap) return;
              const isAbove = sec.compareDocumentPosition(this) & Node.DOCUMENT_POSITION_FOLLOWING;
              if (isAbove && getComputedStyle(sec).position === 'sticky') {
                top += sec.getBoundingClientRect().height;
              }
            });
            wrap.style.setProperty('--subcol-top', Math.round(top) + 'px');
          };
          window.addEventListener('resize', this._syncStickyTop, { passive: true, signal });
          this._syncStickyTop();
        }

        this._revealActive();
      }

      disconnectedCallback() {
        if (this._abort) this._abort.abort();
      }

      // A link whose full URL (path + search) exactly matches the current
      // location wins over the Liquid-side guess — this is what lets filtered
      // link overrides ("Last chance") take the active state.
      _refineActive() {
        const links = this._track.querySelectorAll('.subcol__link');
        let exact = null;
        links.forEach((link) => {
          const url = new URL(link.href, location.origin);
          if (url.pathname === location.pathname && url.search === location.search) exact = link;
        });
        if (!exact || exact.classList.contains('is-active')) return;
        links.forEach((link) => {
          link.classList.remove('is-active');
          link.removeAttribute('aria-current');
        });
        exact.classList.add('is-active');
        exact.setAttribute('aria-current', 'page');
      }

      // Center the active item in the scroll row on load (no smooth scroll —
      // this is initial state, not motion).
      _revealActive() {
        const active = this._track.querySelector('.subcol__link.is-active');
        if (!active) return;
        const item = active.closest('.subcol__item') || active;
        const target = item.offsetLeft - (this._track.clientWidth - item.offsetWidth) / 2;
        if (target > 0) this._track.scrollLeft = target;
      }
    }
    customElements.define('shftd-subcol', ShftdSubcol);
  }

  } catch(e) { console.error(e); }
})();
})();
